/* eslint-disable max-lines */

/**
 * SVG path definitions for word cloud masks
 * Ported from words_cloud_lib.coffee
 */

// Basic shapes
export const BASIC_MASKS = ['', 'circle', 'square', 'diamond']

// SVG path data for complex shapes
// Format: array of path commands ['m'|'l'|'c'|'z', ...coordinates]
export const SVG_PATHS = {
  heart_v: [
    ['m', 453, 111],
    ['c', 460, 111, 468, 111, 476, 112],
    ['c', 527, 117, 586, 163, 593, 253],
    ['l', 593, 282],
    ['c', 586, 368, 522, 473, 334, 605],
    ['c', 145, 473, 81, 368, 74, 282],
    ['l', 74, 253],
    ['c', 81, 163, 140, 117, 191, 112],
    ['c', 199, 111, 207, 111, 214, 111],
    ['c', 273, 111, 301, 136, 334, 175],
    ['c', 366, 136, 394, 111, 453, 111]
  ],
  heart_h: [
    ['m', 413, 58],
    ['c', 418, 58, 423, 58, 428, 59],
    ['c', 459, 62, 495, 90, 499, 145],
    ['l', 499, 163],
    ['c', 495, 215, 456, 279, 341, 360],
    ['c', 225, 279, 186, 215, 182, 163],
    ['l', 182, 145],
    ['c', 186, 90, 222, 62, 253, 59],
    ['c', 258, 58, 263, 58, 268, 58],
    ['c', 304, 58, 321, 73, 341, 97],
    ['c', 360, 73, 377, 58, 413, 58]
  ],
  butterfly_v: [
    ['m', 455, 476],
    ['c', 458, 479, 460, 482, 464, 486],
    ['c', 461, 487, 460, 487, 458, 487],
    ['c', 458, 487, 458, 486, 457, 486],
    ['c', 451, 481, 446, 475, 437, 478],
    ['c', 434, 479, 431, 476, 426, 475],
    ['c', 427, 479, 427, 483, 428, 487],
    ['c', 428, 491, 427, 494, 423, 496],
    ['c', 418, 498, 416, 495, 414, 492],
    ['c', 411, 489, 410, 485, 407, 481],
    ['c', 406, 483, 404, 484, 403, 486],
    ['c', 402, 487, 401, 489, 400, 490],
    ['c', 392, 492, 391, 500, 389, 506],
    ['c', 389, 508, 387, 510, 385, 511],
    ['c', 385, 511, 384, 511, 384, 510],
    ['c', 384, 506, 385, 503, 385, 499],
    ['c', 384, 498, 384, 498, 383, 498],
    ['c', 380, 502, 377, 507, 374, 512],
    ['c', 372, 516, 371, 520, 368, 523],
    ['c', 364, 529, 358, 533, 350, 533],
    ['c', 341, 532, 331, 531, 321, 530],
    ['c', 318, 530, 315, 530, 312, 530],
    ['c', 296, 534, 281, 530, 268, 520],
    ['c', 260, 515, 252, 511, 243, 509],
    ['c', 233, 508, 224, 503, 218, 493],
    ['c', 213, 485, 204, 482, 196, 479],
    ['c', 194, 479, 192, 478, 191, 478],
    ['c', 183, 475, 179, 470, 180, 462],
    ['c', 182, 451, 175, 445, 166, 441],
    ['c', 160, 439, 155, 436, 155, 427],
    ['c', 155, 424, 151, 420, 149, 417],
    ['c', 147, 416, 144, 415, 142, 413],
    ['c', 137, 409, 137, 406, 142, 402],
    ['c', 146, 399, 146, 396, 143, 393],
    ['c', 142, 392, 142, 392, 141, 391],
    ['c', 135, 385, 136, 383, 143, 380],
    ['c', 148, 378, 151, 375, 150, 369],
    ['c', 150, 365, 152, 363, 155, 362],
    ['c', 157, 362, 159, 361, 161, 359],
    ['c', 159, 359, 157, 359, 155, 358],
    ['c', 144, 355, 134, 351, 123, 348],
    ['c', 116, 346, 111, 342, 108, 335],
    ['c', 105, 329, 100, 326, 95, 322],
    ['c', 92, 320, 89, 318, 87, 316],
    ['c', 84, 313, 83, 310, 86, 307],
    ['c', 90, 304, 89, 300, 87, 296],
    ['c', 84, 292, 84, 288, 88, 283],
    ['c', 91, 280, 89, 276, 87, 273],
    ['c', 84, 269, 81, 266, 81, 260],
    ['c', 81, 257, 77, 254, 75, 250],
    ['c', 69, 243, 62, 237, 57, 229],
    ['c', 51, 220, 56, 212, 66, 210],
    ['c', 71, 209, 77, 209, 83, 210],
    ['c', 104, 213, 123, 222, 143, 231],
    ['c', 215, 262, 281, 303, 343, 349],
    ['c', 353, 356, 361, 365, 370, 373],
    ['c', 372, 375, 374, 377, 376, 379],
    ['c', 383, 385, 391, 383, 393, 374],
    ['c', 394, 367, 395, 361, 396, 354],
    ['c', 401, 335, 406, 316, 412, 298],
    ['c', 428, 253, 446, 210, 467, 168],
    ['c', 482, 140, 497, 112, 517, 87],
    ['c', 522, 81, 528, 75, 535, 71],
    ['c', 547, 64, 555, 70, 555, 84],
    ['c', 555, 93, 554, 101, 554, 109],
    ['c', 553, 113, 555, 117, 555, 121],
    ['c', 556, 125, 557, 129, 557, 132],
    ['c', 558, 137, 559, 140, 563, 141],
    ['c', 568, 142, 569, 145, 569, 149],
    ['c', 570, 154, 571, 158, 577, 159],
    ['c', 581, 160, 581, 164, 580, 167],
    ['c', 576, 178, 576, 188, 575, 199],
    ['c', 574, 206, 569, 214, 565, 220],
    ['c', 560, 227, 554, 234, 549, 241],
    ['c', 556, 238, 561, 240, 565, 246],
    ['c', 566, 248, 570, 248, 573, 247],
    ['c', 580, 247, 582, 248, 581, 255],
    ['c', 580, 263, 580, 263, 588, 265],
    ['c', 592, 266, 593, 268, 593, 272],
    ['c', 592, 274, 591, 277, 590, 279],
    ['c', 588, 285, 588, 290, 591, 295],
    ['c', 593, 298, 592, 302, 592, 305],
    ['c', 590, 310, 588, 314, 586, 319],
    ['c', 584, 324, 585, 328, 589, 331],
    ['c', 595, 340, 596, 346, 589, 354],
    ['c', 582, 364, 578, 375, 578, 387],
    ['c', 579, 395, 574, 401, 569, 407],
    ['c', 563, 413, 559, 421, 556, 429],
    ['c', 553, 439, 548, 448, 540, 454],
    ['c', 539, 455, 538, 456, 537, 457],
    ['c', 524, 462, 515, 474, 504, 482],
    ['c', 495, 490, 486, 491, 475, 485],
    ['c', 469, 481, 463, 478, 456, 475],
    ['c', 456, 475, 455, 476, 455, 476]
  ],
  butterfly_h: [
    ['m', 416, 348],
    ['c', 418, 350, 420, 352, 423, 355],
    ['c', 421, 355, 420, 356, 419, 356],
    ['c', 418, 356, 418, 355, 418, 355],
    ['c', 413, 351, 409, 347, 402, 349],
    ['c', 400, 349, 397, 348, 394, 347],
    ['c', 395, 350, 395, 353, 395, 356],
    ['c', 396, 359, 395, 361, 392, 363],
    ['c', 388, 364, 386, 362, 385, 359],
    ['c', 383, 357, 382, 354, 380, 351],
    ['c', 379, 352, 378, 354, 377, 355],
    ['c', 376, 356, 375, 358, 374, 358],
    ['c', 368, 360, 368, 365, 366, 370],
    ['c', 366, 372, 364, 373, 363, 374],
    ['c', 363, 374, 363, 374, 362, 373],
    ['c', 363, 370, 363, 368, 363, 365],
    ['c', 362, 364, 362, 364, 362, 364],
    ['c', 359, 367, 357, 371, 355, 375],
    ['c', 353, 377, 352, 381, 350, 383],
    ['c', 347, 387, 343, 391, 337, 391],
    ['c', 330, 390, 322, 389, 315, 389],
    ['c', 313, 388, 310, 388, 308, 389],
    ['c', 296, 391, 285, 389, 274, 381],
    ['c', 269, 377, 263, 374, 256, 373],
    ['c', 248, 372, 242, 368, 237, 361],
    ['c', 233, 355, 227, 352, 220, 350],
    ['c', 219, 350, 218, 349, 216, 349],
    ['c', 211, 346, 208, 343, 209, 337],
    ['c', 210, 328, 205, 324, 198, 321],
    ['c', 193, 319, 189, 317, 190, 310],
    ['c', 190, 308, 187, 305, 185, 303],
    ['c', 183, 302, 181, 301, 180, 300],
    ['c', 176, 297, 176, 294, 180, 291],
    ['c', 183, 289, 183, 287, 180, 285],
    ['c', 180, 284, 179, 284, 179, 283],
    ['c', 175, 279, 175, 278, 180, 275],
    ['c', 184, 273, 187, 271, 186, 267],
    ['c', 186, 264, 187, 262, 190, 261],
    ['c', 191, 261, 192, 261, 194, 260],
    ['c', 192, 259, 191, 259, 190, 258],
    ['c', 182, 256, 173, 254, 165, 251],
    ['c', 160, 249, 156, 246, 154, 241],
    ['c', 152, 237, 148, 234, 144, 231],
    ['c', 142, 230, 140, 228, 138, 227],
    ['c', 136, 225, 135, 222, 138, 220],
    ['c', 140, 217, 140, 215, 138, 212],
    ['c', 136, 208, 136, 205, 139, 202],
    ['c', 141, 200, 140, 197, 138, 195],
    ['c', 136, 192, 134, 189, 134, 185],
    ['c', 134, 182, 131, 180, 129, 177],
    ['c', 124, 172, 119, 167, 116, 161],
    ['c', 111, 155, 115, 148, 122, 147],
    ['c', 126, 146, 131, 146, 135, 147],
    ['c', 151, 149, 166, 156, 180, 162],
    ['c', 235, 186, 284, 217, 332, 252],
    ['c', 339, 257, 345, 264, 352, 270],
    ['c', 353, 272, 355, 273, 356, 274],
    ['c', 362, 279, 367, 277, 369, 270],
    ['c', 370, 265, 370, 260, 372, 256],
    ['c', 375, 241, 379, 227, 384, 213],
    ['c', 395, 179, 409, 147, 425, 115],
    ['c', 436, 94, 448, 73, 463, 54],
    ['c', 466, 49, 471, 45, 476, 42],
    ['c', 486, 36, 492, 41, 492, 52],
    ['c', 492, 58, 491, 65, 490, 71],
    ['c', 490, 74, 491, 77, 492, 80],
    ['c', 492, 82, 493, 85, 493, 88],
    ['c', 493, 91, 494, 94, 498, 94],
    ['c', 501, 95, 502, 98, 502, 101],
    ['c', 503, 104, 504, 107, 508, 108],
    ['c', 511, 109, 511, 112, 510, 114],
    ['c', 507, 122, 507, 130, 506, 138],
    ['c', 506, 144, 502, 149, 499, 154],
    ['c', 495, 160, 491, 164, 487, 170],
    ['c', 492, 167, 496, 169, 499, 174],
    ['c', 500, 175, 503, 175, 505, 175],
    ['c', 511, 174, 512, 176, 511, 181],
    ['c', 510, 186, 511, 187, 516, 188],
    ['c', 519, 189, 520, 191, 520, 193],
    ['c', 520, 195, 519, 197, 518, 199],
    ['c', 516, 203, 516, 207, 519, 211],
    ['c', 520, 213, 520, 216, 519, 218],
    ['c', 518, 222, 516, 226, 515, 229],
    ['c', 514, 233, 514, 236, 517, 238],
    ['c', 522, 245, 522, 249, 517, 256],
    ['c', 512, 263, 509, 271, 509, 281],
    ['c', 510, 287, 506, 291, 502, 295],
    ['c', 497, 300, 494, 306, 492, 312],
    ['c', 490, 320, 486, 326, 480, 331],
    ['c', 479, 332, 479, 333, 478, 333],
    ['c', 468, 337, 461, 346, 453, 352],
    ['c', 446, 358, 439, 359, 431, 354],
    ['c', 427, 351, 422, 349, 417, 347],
    ['c', 417, 347, 416, 347, 416, 348]
  ],
  shield_v: [
    ['m', 331, 624],
    ['c', 283, 520, 149, 522, 103, 456],
    ['c', 58, 390, 58, 350, 117, 266],
    ['c', 176, 182, 85, 128, 85, 128],
    ['l', 146, 58],
    ['c', 253, 164, 331, 60, 331, 60],
    ['c', 331, 60, 409, 164, 516, 58],
    ['l', 577, 128],
    ['c', 577, 128, 486, 182, 545, 266],
    ['c', 604, 350, 604, 395, 559, 456],
    ['c', 511, 521, 379, 520, 331, 624]
  ],
  shield_h: [
    ['m', 340, 364],
    ['c', 313, 306, 238, 308, 213, 271],
    ['c', 188, 235, 188, 212, 221, 166],
    ['c', 253, 119, 203, 89, 203, 89],
    ['l', 237, 50],
    ['c', 296, 109, 340, 51, 340, 51],
    ['c', 340, 51, 383, 109, 442, 50],
    ['l', 476, 89],
    ['c', 476, 89, 426, 119, 458, 166],
    ['c', 491, 212, 491, 237, 466, 271],
    ['c', 440, 307, 366, 306, 340, 364]
  ],
  leaf_v: [
    ['m', 349, 539],
    ['l', 349, 450],
    ['l', 517, 484],
    ['l', 463, 432],
    ['l', 583, 343],
    ['l', 541, 322],
    ['l', 586, 250],
    ['l', 496, 265],
    ['l', 501, 206],
    ['l', 438, 241],
    ['l', 459, 127],
    ['l', 389, 158],
    ['l', 331, 47],
    ['l', 272, 158],
    ['l', 202, 127],
    ['l', 223, 241],
    ['l', 160, 206],
    ['l', 165, 265],
    ['l', 75, 250],
    ['l', 120, 322],
    ['l', 78, 343],
    ['l', 198, 432],
    ['l', 144, 484],
    ['l', 312, 450],
    ['l', 312, 539],
    ['l', 349, 539]
  ],
  leaf_h: [
    ['m', 344, 387],
    ['l', 344, 322],
    ['l', 468, 347],
    ['l', 428, 309],
    ['l', 515, 244],
    ['l', 485, 228],
    ['l', 518, 176],
    ['l', 452, 186],
    ['l', 456, 143],
    ['l', 409, 169],
    ['l', 425, 86],
    ['l', 374, 108],
    ['l', 331, 27],
    ['l', 289, 108],
    ['l', 237, 86],
    ['l', 253, 169],
    ['l', 206, 143],
    ['l', 210, 186],
    ['l', 144, 176],
    ['l', 177, 228],
    ['l', 147, 244],
    ['l', 234, 309],
    ['l', 195, 347],
    ['l', 318, 322],
    ['l', 318, 387],
    ['l', 344, 387]
  ],
  elephant_h: [
    ['m', 105, 142],
    ['c', 106, 141, 106, 140, 106, 140],
    ['c', 107, 138, 108, 137, 109, 135],
    ['c', 110, 133, 111, 132, 112, 131],
    ['c', 113, 129, 114, 128, 115, 126],
    ['c', 116, 125, 116, 123, 117, 122],
    ['c', 118, 121, 119, 120, 120, 119],
    ['c', 121, 118, 121, 117, 122, 116],
    ['c', 123, 115, 124, 114, 126, 113],
    ['c', 127, 112, 128, 110, 129, 109],
    ['c', 132, 107, 134, 105, 137, 103],
    ['c', 138, 102, 139, 101, 140, 101],
    ['c', 140, 100, 142, 99, 143, 99],
    ['c', 144, 98, 145, 97, 146, 96],
    ['c', 147, 95, 148, 95, 149, 94],
    ['c', 150, 93, 152, 92, 153, 91],
    ['c', 154, 90, 155, 89, 156, 88],
    ['c', 157, 87, 158, 86, 159, 86],
    ['c', 161, 85, 162, 84, 163, 84],
    ['c', 165, 83, 166, 82, 167, 81],
    ['c', 170, 80, 172, 78, 175, 77],
    ['c', 176, 77, 177, 76, 179, 76],
    ['c', 185, 73, 193, 72, 200, 70],
    ['c', 205, 68, 211, 66, 218, 66],
    ['c', 225, 66, 232, 67, 238, 68],
    ['c', 240, 69, 243, 70, 246, 71],
    ['c', 248, 72, 251, 73, 254, 74],
    ['c', 258, 74, 262, 73, 266, 74],
    ['c', 270, 74, 274, 74, 278, 73],
    ['c', 280, 73, 283, 72, 285, 72],
    ['c', 288, 71, 291, 70, 293, 69],
    ['c', 296, 68, 299, 67, 302, 65],
    ['c', 306, 64, 309, 63, 312, 62],
    ['c', 315, 61, 319, 59, 322, 58],
    ['c', 325, 57, 329, 56, 332, 54],
    ['c', 333, 54, 334, 52, 335, 51],
    ['c', 339, 47, 342, 42, 345, 39],
    ['c', 348, 36, 351, 35, 356, 34],
    ['c', 364, 33, 372, 32, 381, 31],
    ['c', 386, 30, 391, 30, 397, 30],
    ['c', 403, 30, 410, 29, 418, 29],
    ['c', 421, 30, 424, 30, 428, 30],
    ['c', 430, 30, 432, 30, 435, 29],
    ['c', 438, 28, 442, 26, 445, 25],
    ['c', 452, 23, 460, 24, 468, 24],
    ['c', 472, 24, 475, 24, 477, 25],
    ['c', 480, 25, 482, 25, 484, 25],
    ['c', 486, 26, 487, 27, 489, 27],
    ['c', 493, 29, 497, 31, 500, 34],
    ['c', 502, 36, 505, 38, 507, 40],
    ['c', 512, 43, 516, 46, 520, 51],
    ['c', 521, 52, 522, 53, 523, 54],
    ['c', 524, 56, 525, 57, 526, 58],
    ['c', 526, 59, 527, 60, 528, 61],
    ['c', 530, 63, 532, 65, 534, 68],
    ['c', 536, 69, 537, 71, 538, 73],
    ['c', 541, 77, 543, 80, 545, 85],
    ['c', 545, 87, 547, 88, 548, 90],
    ['c', 549, 91, 548, 94, 549, 95],
    ['c', 551, 99, 554, 102, 556, 105],
    ['c', 558, 108, 559, 110, 561, 113],
    ['c', 564, 117, 567, 120, 570, 124],
    ['c', 571, 126, 572, 128, 573, 130],
    ['c', 574, 132, 574, 134, 575, 136],
    ['c', 575, 137, 575, 138, 575, 139],
    ['c', 576, 141, 577, 141, 577, 143],
    ['c', 580, 145, 584, 146, 585, 150],
    ['c', 589, 149, 592, 146, 596, 148],
    ['c', 596, 151, 593, 151, 592, 153],
    ['c', 598, 154, 605, 154, 612, 153],
    ['c', 616, 152, 620, 151, 625, 150],
    ['c', 628, 149, 638, 146, 638, 147],
    ['c', 638, 149, 627, 156, 626, 157],
    ['c', 625, 159, 623, 160, 621, 160],
    ['c', 617, 162, 610, 164, 604, 165],
    ['c', 597, 165, 590, 166, 583, 165],
    ['c', 584, 168, 585, 172, 584, 177],
    ['c', 584, 178, 584, 179, 584, 180],
    ['c', 584, 183, 585, 184, 586, 187],
    ['c', 586, 188, 586, 191, 586, 193],
    ['c', 586, 194, 585, 195, 585, 196],
    ['c', 585, 197, 586, 198, 586, 199],
    ['c', 586, 200, 585, 202, 585, 203],
    ['c', 585, 205, 586, 206, 586, 207],
    ['c', 586, 208, 584, 209, 584, 210],
    ['c', 583, 213, 584, 216, 583, 218],
    ['c', 582, 220, 581, 220, 581, 222],
    ['c', 581, 223, 581, 225, 580, 227],
    ['c', 580, 227, 579, 228, 579, 228],
    ['c', 579, 229, 579, 230, 579, 230],
    ['c', 578, 232, 577, 234, 577, 235],
    ['c', 577, 236, 578, 238, 578, 239],
    ['c', 577, 241, 576, 242, 576, 244],
    ['c', 576, 245, 576, 246, 576, 247],
    ['c', 576, 249, 575, 250, 574, 251],
    ['c', 575, 252, 575, 252, 575, 253],
    ['c', 575, 255, 573, 255, 573, 256],
    ['c', 573, 257, 574, 258, 574, 259],
    ['c', 574, 259, 574, 261, 574, 262],
    ['c', 574, 264, 575, 265, 573, 266],
    ['c', 574, 268, 574, 268, 574, 269],
    ['c', 574, 270, 574, 271, 573, 272],
    ['c', 573, 273, 574, 276, 573, 277],
    ['c', 574, 278, 574, 281, 573, 282],
    ['c', 574, 284, 573, 286, 573, 288],
    ['c', 573, 289, 573, 290, 573, 290],
    ['c', 573, 292, 575, 294, 573, 295],
    ['c', 574, 297, 573, 298, 573, 300],
    ['c', 573, 302, 574, 305, 573, 307],
    ['c', 573, 308, 573, 309, 573, 310],
    ['c', 573, 311, 573, 312, 573, 312],
    ['c', 572, 314, 573, 316, 572, 317],
    ['c', 572, 319, 572, 321, 571, 322],
    ['c', 571, 323, 570, 324, 570, 325],
    ['c', 570, 325, 570, 326, 570, 327],
    ['c', 569, 327, 568, 328, 568, 329],
    ['c', 568, 330, 568, 330, 568, 331],
    ['c', 568, 332, 567, 332, 566, 333],
    ['c', 565, 335, 565, 336, 564, 337],
    ['c', 563, 338, 561, 339, 559, 341],
    ['c', 554, 345, 547, 350, 539, 351],
    ['c', 532, 351, 524, 351, 518, 350],
    ['c', 516, 350, 513, 348, 512, 347],
    ['c', 510, 345, 510, 341, 514, 341],
    ['c', 516, 338, 518, 332, 521, 330],
    ['c', 522, 329, 525, 329, 526, 329],
    ['c', 527, 330, 528, 331, 529, 332],
    ['c', 530, 333, 531, 335, 532, 335],
    ['c', 534, 336, 538, 333, 539, 332],
    ['c', 544, 329, 545, 318, 544, 309],
    ['c', 544, 305, 543, 300, 542, 295],
    ['c', 541, 290, 542, 285, 541, 280],
    ['c', 540, 270, 539, 260, 538, 251],
    ['c', 538, 248, 538, 246, 538, 244],
    ['c', 538, 237, 538, 230, 537, 223],
    ['c', 536, 215, 531, 209, 530, 202],
    ['c', 529, 200, 529, 198, 528, 195],
    ['c', 527, 193, 526, 191, 526, 189],
    ['c', 525, 187, 526, 184, 525, 182],
    ['c', 523, 171, 510, 171, 501, 168],
    ['c', 497, 171, 492, 179, 492, 179],
    ['c', 492, 179, 489, 183, 488, 184],
    ['c', 487, 184, 485, 185, 484, 186],
    ['c', 481, 187, 476, 189, 472, 189],
    ['c', 466, 189, 460, 190, 454, 191],
    ['c', 452, 192, 451, 192, 450, 192],
    ['c', 449, 192, 448, 193, 447, 193],
    ['c', 445, 193, 443, 194, 442, 194],
    ['c', 439, 194, 437, 194, 435, 196],
    ['c', 435, 197, 434, 197, 434, 198],
    ['c', 432, 199, 430, 202, 429, 205],
    ['c', 429, 205, 429, 206, 429, 207],
    ['c', 427, 213, 425, 219, 424, 225],
    ['c', 424, 228, 424, 230, 424, 233],
    ['c', 424, 240, 424, 247, 425, 253],
    ['c', 426, 258, 427, 262, 428, 266],
    ['c', 430, 270, 433, 273, 435, 276],
    ['c', 435, 277, 436, 278, 436, 279],
    ['c', 437, 281, 438, 283, 439, 285],
    ['c', 440, 287, 441, 289, 442, 290],
    ['c', 443, 292, 446, 294, 447, 296],
    ['c', 449, 299, 450, 302, 452, 306],
    ['c', 453, 309, 455, 312, 456, 315],
    ['c', 458, 321, 458, 326, 457, 332],
    ['c', 457, 333, 457, 334, 457, 336],
    ['c', 456, 337, 456, 338, 456, 339],
    ['c', 455, 341, 454, 344, 453, 346],
    ['c', 452, 349, 449, 353, 446, 354],
    ['c', 442, 359, 439, 360, 436, 364],
    ['c', 434, 366, 432, 368, 431, 371],
    ['c', 431, 372, 430, 373, 430, 374],
    ['c', 430, 375, 430, 376, 430, 377],
    ['c', 430, 381, 429, 386, 427, 389],
    ['c', 425, 394, 420, 397, 412, 397],
    ['c', 411, 397, 410, 397, 408, 397],
    ['c', 407, 397, 406, 397, 405, 397],
    ['c', 404, 397, 403, 397, 401, 397],
    ['c', 400, 397, 399, 397, 397, 397],
    ['c', 396, 397, 395, 397, 393, 397],
    ['c', 392, 397, 390, 397, 389, 397],
    ['c', 388, 397, 387, 397, 386, 397],
    ['c', 380, 398, 373, 399, 369, 396],
    ['c', 368, 395, 367, 393, 367, 391],
    ['c', 367, 389, 367, 386, 367, 384],
    ['c', 366, 383, 366, 382, 366, 381],
    ['c', 366, 380, 365, 379, 365, 377],
    ['c', 365, 375, 364, 373, 364, 370],
    ['c', 364, 363, 364, 356, 363, 349],
    ['c', 363, 345, 362, 342, 362, 339],
    ['c', 362, 333, 362, 326, 362, 320],
    ['c', 361, 318, 361, 317, 360, 315],
    ['c', 360, 313, 360, 312, 359, 310],
    ['c', 358, 307, 357, 304, 356, 301],
    ['c', 355, 297, 356, 293, 355, 290],
    ['c', 354, 289, 354, 288, 353, 287],
    ['c', 353, 287, 352, 286, 352, 285],
    ['c', 351, 284, 350, 282, 350, 281],
    ['c', 349, 280, 348, 278, 347, 277],
    ['c', 347, 276, 345, 275, 344, 274],
    ['c', 342, 272, 341, 267, 340, 264],
    ['c', 339, 262, 338, 260, 337, 257],
    ['c', 337, 256, 335, 252, 334, 252],
    ['c', 332, 252, 329, 254, 327, 255],
    ['c', 324, 256, 322, 257, 320, 258],
    ['c', 318, 259, 316, 259, 314, 260],
    ['c', 307, 263, 301, 265, 295, 267],
    ['c', 293, 268, 292, 269, 290, 269],
    ['c', 289, 270, 287, 270, 286, 271],
    ['c', 285, 271, 285, 271, 284, 272],
    ['c', 283, 272, 282, 272, 282, 272],
    ['c', 279, 273, 277, 274, 275, 275],
    ['c', 273, 276, 271, 277, 269, 278],
    ['c', 268, 278, 267, 279, 266, 280],
    ['c', 264, 281, 263, 280, 259, 282],
    ['c', 256, 282, 254, 283, 251, 284],
    ['c', 250, 284, 248, 283, 247, 284],
    ['c', 246, 284, 245, 289, 244, 291],
    ['c', 242, 293, 242, 293, 241, 295],
    ['c', 240, 298, 240, 300, 239, 304],
    ['c', 239, 305, 238, 307, 238, 308],
    ['c', 237, 313, 238, 317, 239, 321],
    ['c', 241, 328, 242, 335, 243, 341],
    ['c', 244, 343, 244, 344, 245, 346],
    ['c', 245, 350, 247, 353, 248, 357],
    ['c', 249, 358, 249, 360, 250, 362],
    ['c', 251, 364, 251, 366, 252, 367],
    ['c', 253, 369, 254, 371, 255, 373],
    ['c', 258, 377, 263, 380, 267, 383],
    ['c', 268, 384, 269, 384, 269, 385],
    ['c', 270, 386, 271, 388, 272, 388],
    ['c', 272, 389, 272, 394, 272, 396],
    ['c', 272, 397, 269, 400, 267, 400],
    ['c', 264, 400, 259, 400, 254, 400],
    ['c', 249, 400, 244, 399, 241, 398],
    ['c', 240, 398, 239, 398, 239, 397],
    ['c', 235, 397, 231, 397, 228, 397],
    ['c', 226, 397, 224, 397, 222, 397],
    ['c', 221, 397, 219, 397, 217, 397],
    ['c', 215, 396, 214, 393, 212, 390],
    ['c', 211, 386, 210, 383, 210, 380],
    ['c', 210, 379, 210, 378, 210, 376],
    ['c', 210, 372, 209, 369, 209, 365],
    ['c', 208, 361, 207, 357, 207, 354],
    ['c', 207, 353, 206, 352, 206, 351],
    ['c', 206, 349, 205, 349, 205, 348],
    ['c', 204, 345, 204, 341, 204, 338],
    ['c', 203, 336, 202, 333, 201, 331],
    ['c', 200, 328, 199, 326, 198, 324],
    ['c', 195, 319, 193, 315, 188, 312],
    ['c', 185, 310, 181, 310, 177, 309],
    ['c', 172, 307, 169, 304, 165, 300],
    ['c', 162, 303, 159, 304, 155, 306],
    ['c', 154, 307, 153, 308, 151, 309],
    ['c', 148, 311, 146, 312, 143, 315],
    ['c', 142, 316, 140, 317, 140, 319],
    ['c', 140, 319, 139, 320, 139, 321],
    ['c', 139, 322, 138, 323, 138, 324],
    ['c', 137, 326, 137, 328, 137, 331],
    ['c', 136, 332, 135, 333, 134, 335],
    ['c', 134, 335, 133, 336, 133, 337],
    ['c', 133, 338, 132, 338, 132, 339],
    ['c', 131, 342, 131, 346, 130, 350],
    ['c', 129, 353, 129, 357, 128, 360],
    ['c', 127, 364, 127, 368, 127, 371],
    ['c', 126, 375, 126, 379, 126, 383],
    ['c', 126, 385, 128, 387, 128, 388],
    ['c', 129, 393, 129, 397, 125, 397],
    ['c', 122, 398, 117, 397, 114, 397],
    ['c', 107, 397, 100, 397, 94, 397],
    ['c', 89, 397, 81, 399, 81, 393],
    ['c', 81, 391, 82, 390, 82, 389],
    ['c', 83, 387, 82, 385, 83, 384],
    ['c', 82, 381, 84, 378, 84, 375],
    ['c', 85, 374, 85, 372, 85, 371],
    ['c', 86, 367, 88, 363, 89, 358],
    ['c', 89, 357, 89, 355, 90, 354],
    ['c', 90, 352, 91, 351, 91, 350],
    ['c', 92, 348, 91, 346, 92, 344],
    ['c', 92, 340, 93, 338, 94, 334],
    ['c', 94, 333, 94, 332, 94, 331],
    ['c', 94, 330, 94, 329, 93, 327],
    ['c', 93, 326, 93, 325, 93, 323],
    ['c', 93, 322, 93, 321, 93, 320],
    ['c', 93, 318, 93, 317, 93, 315],
    ['c', 93, 314, 93, 312, 93, 311],
    ['c', 92, 310, 93, 308, 92, 307],
    ['c', 92, 303, 92, 299, 92, 296],
    ['c', 92, 294, 92, 290, 92, 290],
    ['c', 92, 290, 91, 282, 91, 278],
    ['c', 91, 273, 91, 269, 92, 264],
    ['c', 92, 254, 94, 243, 94, 234],
    ['c', 91, 246, 89, 258, 86, 271],
    ['c', 84, 279, 82, 289, 80, 298],
    ['c', 79, 301, 77, 305, 77, 307],
    ['c', 77, 308, 78, 309, 78, 309],
    ['c', 78, 314, 77, 319, 75, 324],
    ['c', 74, 325, 73, 327, 72, 329],
    ['c', 71, 331, 70, 333, 69, 334],
    ['c', 66, 337, 61, 342, 57, 344],
    ['c', 55, 344, 51, 348, 52, 345],
    ['c', 52, 343, 56, 338, 58, 336],
    ['c', 60, 334, 61, 331, 62, 329],
    ['c', 64, 322, 64, 315, 67, 311],
    ['c', 68, 310, 70, 309, 70, 309],
    ['c', 71, 308, 72, 304, 72, 301],
    ['c', 74, 296, 75, 291, 76, 285],
    ['c', 76, 282, 77, 280, 77, 277],
    ['c', 78, 276, 78, 275, 78, 274],
    ['c', 78, 273, 79, 270, 79, 268],
    ['c', 80, 266, 80, 264, 80, 262],
    ['c', 80, 261, 81, 260, 81, 259],
    ['c', 81, 257, 81, 256, 81, 255],
    ['c', 82, 252, 82, 250, 83, 247],
    ['c', 83, 241, 84, 233, 85, 227],
    ['c', 85, 225, 85, 223, 85, 220],
    ['c', 86, 218, 86, 216, 86, 214],
    ['c', 86, 211, 87, 209, 87, 207],
    ['c', 88, 202, 88, 197, 88, 193],
    ['c', 88, 187, 87, 181, 88, 177],
    ['c', 89, 175, 90, 173, 91, 172],
    ['c', 93, 165, 96, 158, 99, 153],
    ['l', 105, 142],
    ['l', 105, 142],
    ['z'],
    ['m', 413, 339],
    ['l', 413, 339],
    ['c', 414, 338, 416, 338, 416, 337],
    ['c', 418, 336, 418, 334, 419, 332],
    ['c', 419, 329, 420, 327, 420, 325],
    ['c', 419, 323, 415, 322, 413, 320],
    ['c', 410, 319, 408, 317, 406, 316],
    ['c', 406, 316, 406, 317, 406, 317],
    ['c', 406, 320, 406, 325, 405, 328],
    ['c', 405, 331, 405, 334, 405, 337],
    ['c', 405, 339, 404, 341, 405, 342],
    ['c', 409, 343, 410, 341, 413, 339]
  ],
  elephant_v: [
    ['m', 114, 208],
    ['c', 115, 207, 115, 207, 115, 206],
    ['c', 116, 204, 117, 203, 117, 202],
    ['c', 118, 200, 120, 199, 121, 198],
    ['c', 121, 196, 123, 195, 123, 194],
    ['c', 124, 192, 125, 191, 125, 190],
    ['c', 126, 189, 127, 188, 128, 187],
    ['c', 129, 186, 129, 185, 130, 185],
    ['c', 130, 184, 132, 183, 133, 181],
    ['c', 134, 180, 135, 179, 136, 178],
    ['c', 138, 176, 141, 174, 143, 172],
    ['c', 144, 172, 145, 171, 146, 170],
    ['c', 147, 169, 148, 169, 149, 168],
    ['c', 149, 168, 150, 167, 151, 166],
    ['c', 152, 165, 154, 165, 155, 164],
    ['c', 156, 163, 157, 162, 158, 161],
    ['c', 159, 160, 160, 160, 161, 159],
    ['c', 162, 158, 163, 157, 164, 156],
    ['c', 165, 156, 166, 155, 168, 154],
    ['c', 169, 154, 170, 153, 171, 152],
    ['c', 174, 151, 176, 150, 178, 149],
    ['c', 179, 148, 181, 148, 182, 147],
    ['c', 187, 145, 195, 144, 201, 142],
    ['c', 206, 140, 211, 138, 218, 138],
    ['c', 224, 138, 230, 139, 236, 140],
    ['c', 238, 141, 241, 142, 243, 143],
    ['c', 246, 144, 248, 145, 251, 145],
    ['c', 255, 146, 258, 145, 262, 145],
    ['c', 266, 146, 269, 145, 273, 145],
    ['c', 275, 145, 277, 144, 280, 143],
    ['c', 282, 143, 284, 142, 286, 141],
    ['c', 289, 141, 292, 139, 295, 138],
    ['c', 298, 137, 301, 136, 304, 135],
    ['c', 307, 133, 310, 132, 313, 131],
    ['c', 316, 130, 319, 129, 322, 128],
    ['c', 323, 127, 324, 125, 325, 124],
    ['c', 328, 121, 331, 116, 335, 113],
    ['c', 337, 111, 340, 110, 344, 109],
    ['c', 352, 108, 359, 107, 367, 106],
    ['c', 372, 106, 377, 105, 382, 105],
    ['c', 388, 105, 394, 105, 401, 105],
    ['c', 404, 105, 407, 105, 410, 105],
    ['c', 412, 105, 414, 105, 417, 104],
    ['c', 420, 103, 423, 102, 426, 101],
    ['c', 433, 99, 440, 99, 448, 100],
    ['c', 450, 100, 453, 100, 456, 100],
    ['c', 458, 101, 460, 100, 462, 101],
    ['c', 463, 101, 465, 102, 466, 103],
    ['c', 470, 105, 473, 107, 477, 109],
    ['c', 479, 111, 481, 113, 483, 114],
    ['c', 488, 118, 492, 120, 495, 125],
    ['c', 496, 126, 497, 127, 498, 128],
    ['c', 499, 129, 499, 130, 500, 131],
    ['c', 501, 132, 501, 132, 502, 133],
    ['c', 504, 136, 506, 138, 508, 140],
    ['c', 509, 141, 510, 143, 512, 145],
    ['c', 514, 148, 516, 151, 517, 156],
    ['c', 518, 157, 520, 158, 521, 160],
    ['c', 521, 161, 520, 164, 521, 165],
    ['c', 523, 168, 526, 172, 528, 174],
    ['c', 530, 177, 531, 179, 533, 181],
    ['c', 535, 185, 538, 188, 541, 192],
    ['c', 542, 194, 543, 195, 543, 197],
    ['c', 544, 199, 544, 201, 545, 203],
    ['c', 545, 204, 545, 205, 546, 206],
    ['c', 546, 207, 547, 208, 548, 209],
    ['c', 550, 210, 553, 212, 555, 215],
    ['c', 558, 215, 561, 212, 564, 213],
    ['c', 565, 216, 562, 216, 561, 218],
    ['c', 567, 219, 573, 219, 579, 218],
    ['c', 583, 217, 586, 216, 591, 215],
    ['c', 594, 215, 603, 212, 603, 213],
    ['c', 603, 214, 593, 221, 592, 222],
    ['c', 591, 223, 589, 224, 588, 225],
    ['c', 584, 226, 578, 228, 572, 229],
    ['c', 566, 230, 559, 230, 553, 229],
    ['c', 554, 232, 554, 236, 554, 240],
    ['c', 554, 241, 553, 242, 553, 243],
    ['c', 554, 245, 555, 247, 555, 249],
    ['c', 556, 251, 556, 253, 555, 255],
    ['c', 555, 256, 555, 257, 555, 258],
    ['c', 555, 259, 555, 260, 555, 261],
    ['c', 556, 262, 555, 263, 555, 264],
    ['c', 555, 265, 555, 266, 555, 267],
    ['c', 555, 269, 554, 270, 553, 271],
    ['c', 553, 273, 553, 276, 552, 278],
    ['c', 552, 280, 551, 279, 550, 281],
    ['c', 551, 283, 551, 284, 550, 286],
    ['c', 550, 286, 549, 287, 549, 287],
    ['c', 549, 288, 549, 289, 549, 289],
    ['c', 548, 291, 548, 292, 547, 293],
    ['c', 548, 295, 548, 296, 548, 297],
    ['c', 548, 299, 547, 300, 546, 301],
    ['c', 546, 302, 547, 304, 546, 304],
    ['c', 546, 306, 545, 307, 545, 308],
    ['c', 545, 309, 545, 309, 545, 310],
    ['c', 545, 311, 544, 312, 544, 313],
    ['c', 544, 313, 544, 314, 544, 315],
    ['c', 545, 316, 544, 317, 544, 318],
    ['c', 544, 320, 545, 321, 544, 322],
    ['c', 544, 323, 545, 324, 545, 325],
    ['c', 545, 326, 544, 326, 544, 327],
    ['c', 544, 329, 545, 331, 543, 332],
    ['c', 544, 333, 544, 335, 543, 337],
    ['c', 544, 338, 544, 340, 544, 342],
    ['c', 544, 343, 544, 344, 544, 344],
    ['c', 544, 345, 545, 347, 544, 349],
    ['c', 545, 350, 544, 351, 544, 353],
    ['c', 544, 355, 544, 358, 543, 360],
    ['c', 543, 361, 544, 361, 544, 362],
    ['c', 544, 363, 543, 364, 543, 364],
    ['c', 543, 366, 544, 367, 542, 368],
    ['c', 543, 370, 542, 372, 542, 374],
    ['c', 542, 374, 541, 375, 541, 376],
    ['c', 541, 376, 541, 377, 541, 377],
    ['c', 540, 378, 539, 379, 539, 380],
    ['c', 539, 380, 539, 381, 539, 381],
    ['c', 539, 382, 538, 383, 537, 384],
    ['c', 537, 385, 536, 386, 535, 387],
    ['c', 535, 388, 533, 389, 531, 391],
    ['c', 526, 395, 519, 399, 512, 400],
    ['c', 506, 400, 498, 400, 493, 399],
    ['c', 492, 399, 488, 397, 487, 396],
    ['c', 486, 394, 486, 391, 489, 391],
    ['c', 491, 388, 493, 383, 496, 380],
    ['c', 496, 380, 499, 380, 500, 380],
    ['c', 501, 380, 502, 381, 503, 382],
    ['c', 504, 383, 505, 385, 506, 385],
    ['c', 507, 386, 512, 384, 513, 383],
    ['c', 517, 379, 518, 370, 517, 362],
    ['c', 517, 358, 516, 353, 515, 349],
    ['c', 515, 344, 515, 339, 514, 335],
    ['c', 514, 326, 512, 317, 512, 308],
    ['c', 511, 306, 512, 303, 512, 301],
    ['c', 511, 295, 511, 289, 511, 282],
    ['c', 510, 275, 505, 270, 504, 263],
    ['c', 503, 261, 503, 259, 502, 257],
    ['c', 501, 255, 500, 253, 500, 251],
    ['c', 500, 249, 500, 246, 500, 244],
    ['c', 497, 235, 486, 235, 478, 232],
    ['c', 474, 234, 469, 242, 469, 242],
    ['c', 469, 242, 467, 245, 465, 246],
    ['c', 464, 247, 463, 247, 462, 248],
    ['c', 459, 249, 455, 251, 451, 251],
    ['c', 445, 251, 439, 252, 434, 253],
    ['c', 433, 254, 431, 254, 430, 254],
    ['c', 429, 254, 429, 255, 428, 255],
    ['c', 426, 255, 425, 255, 423, 256],
    ['c', 421, 256, 419, 256, 417, 258],
    ['c', 416, 258, 416, 259, 416, 259],
    ['c', 414, 260, 412, 263, 412, 266],
    ['c', 411, 266, 411, 267, 411, 268],
    ['c', 410, 273, 408, 279, 407, 285],
    ['c', 407, 287, 407, 289, 407, 291],
    ['c', 406, 298, 406, 304, 408, 310],
    ['c', 409, 315, 409, 318, 411, 322],
    ['c', 412, 325, 415, 328, 416, 331],
    ['c', 417, 332, 418, 333, 418, 334],
    ['c', 419, 336, 420, 338, 420, 339],
    ['c', 421, 341, 422, 343, 423, 344],
    ['c', 424, 346, 427, 348, 428, 350],
    ['c', 429, 352, 431, 355, 432, 358],
    ['c', 434, 361, 435, 364, 436, 367],
    ['c', 438, 372, 438, 377, 437, 382],
    ['c', 437, 383, 437, 385, 437, 386],
    ['c', 436, 387, 436, 388, 436, 389],
    ['c', 435, 391, 434, 393, 433, 396],
    ['c', 433, 398, 430, 402, 427, 403],
    ['c', 423, 407, 421, 408, 418, 411],
    ['c', 416, 413, 414, 415, 413, 418],
    ['c', 413, 419, 413, 420, 412, 421],
    ['c', 412, 422, 413, 423, 413, 424],
    ['c', 413, 428, 411, 432, 410, 434],
    ['c', 408, 439, 403, 442, 396, 442],
    ['c', 395, 442, 394, 442, 392, 442],
    ['c', 392, 442, 391, 442, 390, 442],
    ['c', 388, 442, 387, 442, 386, 442],
    ['c', 385, 442, 384, 442, 382, 442],
    ['c', 381, 442, 380, 442, 378, 442],
    ['c', 377, 442, 376, 442, 375, 442],
    ['c', 374, 442, 373, 442, 372, 442],
    ['c', 366, 443, 360, 444, 357, 441],
    ['c', 356, 440, 355, 438, 355, 437],
    ['c', 354, 435, 355, 432, 354, 430],
    ['c', 354, 429, 354, 428, 354, 427],
    ['c', 353, 426, 353, 425, 353, 424],
    ['c', 353, 422, 352, 420, 352, 418],
    ['c', 352, 411, 352, 404, 351, 398],
    ['c', 351, 395, 350, 392, 350, 389],
    ['c', 350, 383, 350, 377, 349, 371],
    ['c', 349, 370, 349, 368, 349, 367],
    ['c', 348, 365, 348, 364, 347, 362],
    ['c', 346, 359, 345, 357, 344, 354],
    ['c', 344, 351, 344, 347, 343, 344],
    ['c', 343, 343, 342, 342, 342, 341],
    ['c', 341, 341, 341, 340, 341, 339],
    ['c', 340, 338, 339, 337, 339, 336],
    ['c', 338, 334, 337, 333, 336, 332],
    ['c', 336, 331, 335, 330, 334, 329],
    ['c', 332, 327, 330, 323, 329, 320],
    ['c', 329, 318, 328, 316, 327, 314],
    ['c', 327, 312, 325, 309, 324, 309],
    ['c', 322, 309, 320, 311, 318, 312],
    ['c', 315, 313, 313, 313, 311, 314],
    ['c', 309, 315, 307, 316, 306, 316],
    ['c', 300, 319, 294, 321, 288, 323],
    ['c', 286, 324, 285, 324, 284, 325],
    ['c', 283, 325, 281, 326, 280, 326],
    ['c', 280, 326, 279, 327, 278, 327],
    ['c', 278, 327, 277, 327, 276, 328],
    ['c', 274, 328, 272, 329, 270, 330],
    ['c', 268, 331, 266, 332, 265, 333],
    ['c', 264, 333, 263, 334, 262, 334],
    ['c', 260, 335, 259, 335, 256, 337],
    ['c', 253, 337, 251, 338, 248, 338],
    ['c', 247, 338, 246, 338, 245, 338],
    ['c', 243, 339, 242, 343, 241, 344],
    ['c', 240, 346, 240, 347, 239, 349],
    ['c', 238, 351, 238, 353, 237, 356],
    ['c', 237, 358, 236, 359, 236, 361],
    ['c', 236, 365, 237, 368, 237, 373],
    ['c', 239, 379, 240, 385, 241, 390],
    ['c', 241, 392, 242, 394, 242, 396],
    ['c', 243, 399, 245, 402, 246, 405],
    ['c', 246, 407, 247, 408, 247, 410],
    ['c', 248, 412, 248, 413, 249, 415],
    ['c', 250, 417, 251, 418, 252, 420],
    ['c', 254, 424, 259, 427, 263, 429],
    ['c', 263, 430, 264, 430, 265, 431],
    ['c', 266, 432, 267, 433, 267, 434],
    ['c', 267, 435, 268, 439, 267, 441],
    ['c', 267, 442, 265, 444, 263, 445],
    ['c', 260, 445, 255, 445, 251, 445],
    ['c', 246, 444, 242, 444, 239, 443],
    ['c', 238, 443, 237, 443, 237, 442],
    ['c', 233, 442, 230, 442, 227, 442],
    ['c', 225, 442, 224, 442, 222, 442],
    ['c', 220, 442, 218, 442, 217, 442],
    ['c', 215, 441, 214, 438, 213, 435],
    ['c', 212, 432, 211, 429, 210, 426],
    ['c', 210, 425, 211, 424, 211, 423],
    ['c', 210, 419, 209, 416, 209, 413],
    ['c', 209, 409, 208, 406, 207, 402],
    ['c', 207, 401, 207, 401, 207, 400],
    ['c', 207, 398, 206, 398, 206, 397],
    ['c', 205, 394, 205, 391, 205, 388],
    ['c', 204, 386, 203, 383, 202, 381],
    ['c', 201, 379, 200, 377, 199, 375],
    ['c', 197, 370, 195, 367, 191, 364],
    ['c', 188, 363, 183, 362, 180, 361],
    ['c', 176, 360, 173, 356, 169, 353],
    ['c', 166, 356, 163, 357, 160, 358],
    ['c', 159, 359, 158, 360, 157, 361],
    ['c', 154, 363, 152, 364, 149, 367],
    ['c', 148, 368, 147, 369, 146, 370],
    ['c', 146, 371, 145, 372, 145, 372],
    ['c', 145, 373, 144, 374, 144, 375],
    ['c', 143, 377, 144, 379, 143, 381],
    ['c', 143, 383, 141, 383, 141, 385],
    ['c', 140, 385, 140, 386, 140, 387],
    ['c', 139, 388, 139, 388, 139, 389],
    ['c', 138, 392, 138, 395, 137, 399],
    ['c', 136, 402, 136, 405, 135, 408],
    ['c', 134, 412, 134, 415, 134, 419],
    ['c', 134, 422, 133, 426, 133, 429],
    ['c', 133, 431, 135, 432, 135, 434],
    ['c', 136, 438, 136, 442, 132, 442],
    ['c', 130, 443, 125, 442, 122, 442],
    ['c', 116, 442, 110, 442, 104, 442],
    ['c', 99, 442, 92, 444, 92, 438],
    ['c', 92, 437, 93, 436, 93, 435],
    ['c', 94, 433, 93, 431, 94, 430],
    ['c', 93, 427, 94, 425, 95, 422],
    ['c', 96, 421, 96, 419, 96, 418],
    ['c', 97, 414, 99, 411, 100, 406],
    ['c', 100, 405, 100, 403, 100, 402],
    ['c', 100, 401, 101, 400, 101, 399],
    ['c', 102, 397, 102, 395, 102, 393],
    ['c', 102, 390, 103, 387, 104, 385],
    ['c', 104, 384, 104, 382, 104, 382],
    ['c', 104, 380, 104, 379, 104, 378],
    ['c', 103, 377, 103, 376, 103, 374],
    ['c', 103, 373, 103, 372, 103, 371],
    ['c', 103, 369, 103, 369, 103, 367],
    ['c', 103, 366, 103, 364, 103, 363],
    ['c', 103, 362, 103, 360, 103, 359],
    ['c', 102, 356, 102, 353, 102, 349],
    ['c', 102, 347, 102, 343, 102, 343],
    ['c', 102, 343, 101, 337, 101, 332],
    ['c', 102, 328, 102, 324, 102, 320],
    ['c', 102, 311, 104, 301, 104, 292],
    ['c', 102, 303, 99, 314, 97, 326],
    ['c', 95, 334, 93, 343, 91, 351],
    ['c', 90, 354, 89, 357, 89, 360],
    ['c', 89, 360, 89, 361, 89, 362],
    ['c', 89, 366, 88, 371, 86, 375],
    ['c', 86, 376, 85, 378, 84, 379],
    ['c', 83, 381, 82, 383, 81, 384],
    ['c', 78, 387, 74, 392, 70, 393],
    ['c', 68, 394, 65, 397, 65, 395],
    ['c', 65, 393, 69, 388, 71, 386],
    ['c', 72, 384, 74, 381, 75, 379],
    ['c', 77, 373, 76, 367, 80, 363],
    ['c', 80, 362, 82, 362, 82, 361],
    ['c', 83, 360, 83, 356, 84, 354],
    ['c', 86, 349, 86, 345, 87, 339],
    ['c', 88, 337, 88, 334, 89, 332],
    ['c', 89, 331, 89, 330, 89, 330],
    ['c', 89, 328, 90, 326, 90, 324],
    ['c', 91, 322, 91, 320, 91, 318],
    ['c', 92, 317, 92, 316, 92, 315],
    ['c', 92, 314, 92, 313, 93, 311],
    ['c', 93, 309, 93, 307, 93, 304],
    ['c', 94, 299, 95, 292, 95, 286],
    ['c', 96, 284, 96, 282, 96, 280],
    ['c', 96, 278, 97, 276, 97, 274],
    ['c', 97, 272, 97, 270, 98, 268],
    ['c', 98, 263, 98, 259, 99, 254],
    ['c', 99, 249, 98, 244, 99, 240],
    ['c', 99, 239, 100, 237, 101, 235],
    ['c', 103, 229, 106, 223, 108, 218],
    ['l', 114, 208],
    ['l', 114, 208],
    ['z'],
    ['m', 397, 389],
    ['l', 397, 389],
    ['c', 398, 388, 399, 388, 400, 387],
    ['c', 401, 386, 401, 385, 402, 382],
    ['c', 402, 380, 404, 378, 403, 376],
    ['c', 402, 375, 399, 373, 397, 372],
    ['c', 394, 370, 392, 368, 391, 367],
    ['c', 390, 368, 390, 368, 390, 369],
    ['c', 390, 372, 390, 376, 390, 379],
    ['c', 390, 382, 390, 385, 389, 387],
    ['c', 389, 389, 389, 391, 390, 392],
    ['c', 393, 392, 394, 390, 397, 389]
  ],
  shark_v: [
    ['m', 276, 163],
    ['c', 284, 165, 290, 169, 296, 174],
    ['c', 296, 174, 297, 175, 297, 175],
    ['c', 301, 179, 304, 185, 307, 190],
    ['c', 315, 201, 321, 209, 329, 220],
    ['c', 331, 222, 333, 225, 335, 227],
    ['c', 337, 230, 340, 233, 342, 234],
    ['c', 344, 234, 347, 235, 349, 235],
    ['c', 351, 236, 352, 237, 354, 238],
    ['c', 356, 238, 357, 238, 359, 239],
    ['c', 361, 239, 364, 239, 368, 240],
    ['c', 374, 241, 382, 243, 390, 244],
    ['c', 396, 245, 401, 245, 407, 247],
    ['c', 415, 249, 424, 250, 432, 252],
    ['c', 436, 254, 440, 254, 446, 255],
    ['c', 448, 255, 450, 256, 452, 257],
    ['c', 454, 257, 456, 258, 459, 258],
    ['c', 489, 265, 518, 273, 547, 283],
    ['c', 550, 284, 553, 285, 556, 286],
    ['c', 565, 290, 574, 292, 582, 296],
    ['c', 589, 297, 594, 300, 600, 303],
    ['c', 605, 305, 613, 307, 612, 314],
    ['c', 612, 319, 604, 322, 601, 324],
    ['c', 598, 326, 595, 327, 592, 327],
    ['c', 590, 328, 587, 330, 584, 330],
    ['c', 580, 331, 575, 331, 571, 332],
    ['c', 567, 333, 563, 335, 558, 335],
    ['c', 558, 336, 558, 340, 557, 341],
    ['c', 556, 342, 553, 342, 551, 343],
    ['c', 548, 344, 547, 346, 545, 346],
    ['c', 538, 349, 528, 349, 519, 350],
    ['c', 514, 350, 510, 351, 505, 351],
    ['c', 501, 352, 496, 351, 491, 352],
    ['c', 489, 352, 487, 354, 484, 354],
    ['c', 462, 356, 440, 356, 419, 356],
    ['c', 416, 360, 414, 365, 410, 369],
    ['c', 408, 371, 405, 372, 404, 374],
    ['c', 402, 376, 401, 379, 399, 380],
    ['c', 395, 384, 390, 387, 386, 389],
    ['c', 383, 391, 376, 393, 372, 392],
    ['c', 369, 391, 369, 388, 368, 384],
    ['c', 361, 392, 352, 399, 343, 407],
    ['c', 342, 408, 340, 409, 339, 411],
    ['c', 333, 417, 324, 422, 317, 428],
    ['c', 314, 430, 311, 432, 307, 435],
    ['c', 304, 437, 301, 439, 298, 441],
    ['c', 293, 443, 287, 445, 281, 446],
    ['c', 280, 446, 280, 446, 279, 446],
    ['c', 272, 442, 281, 432, 283, 427],
    ['c', 287, 421, 291, 413, 294, 406],
    ['c', 301, 398, 305, 386, 312, 377],
    ['c', 314, 367, 320, 361, 322, 350],
    ['c', 304, 351, 288, 346, 271, 346],
    ['c', 267, 346, 263, 345, 259, 345],
    ['c', 256, 344, 253, 343, 250, 342],
    ['c', 246, 342, 243, 342, 239, 342],
    ['c', 236, 341, 233, 339, 230, 339],
    ['c', 227, 344, 225, 351, 215, 350],
    ['c', 210, 348, 209, 340, 205, 336],
    ['c', 201, 334, 196, 333, 191, 334],
    ['c', 189, 334, 188, 335, 186, 336],
    ['c', 182, 337, 177, 337, 173, 339],
    ['c', 171, 339, 170, 341, 169, 341],
    ['c', 166, 342, 164, 342, 162, 343],
    ['c', 157, 345, 154, 348, 149, 346],
    ['c', 150, 342, 154, 341, 156, 339],
    ['c', 158, 337, 160, 334, 162, 332],
    ['c', 163, 328, 164, 325, 166, 321],
    ['c', 162, 321, 161, 319, 158, 320],
    ['c', 154, 322, 154, 332, 151, 337],
    ['c', 148, 341, 142, 346, 140, 337],
    ['c', 140, 333, 141, 328, 140, 323],
    ['c', 138, 318, 135, 314, 133, 310],
    ['c', 130, 319, 131, 332, 127, 341],
    ['c', 123, 347, 121, 356, 111, 355],
    ['c', 111, 350, 112, 345, 113, 339],
    ['c', 113, 333, 114, 327, 114, 321],
    ['c', 115, 318, 117, 314, 116, 311],
    ['c', 116, 308, 111, 300, 109, 296],
    ['c', 102, 281, 96, 264, 85, 253],
    ['c', 81, 252, 76, 256, 74, 252],
    ['c', 73, 250, 75, 247, 75, 245],
    ['c', 75, 243, 73, 239, 72, 238],
    ['c', 70, 234, 64, 233, 62, 227],
    ['c', 62, 226, 62, 225, 62, 224],
    ['c', 63, 221, 67, 222, 71, 222],
    ['c', 74, 223, 75, 225, 78, 226],
    ['c', 96, 244, 115, 260, 132, 279],
    ['c', 136, 276, 139, 269, 139, 262],
    ['c', 139, 258, 136, 248, 140, 247],
    ['c', 145, 246, 149, 253, 151, 255],
    ['c', 154, 259, 156, 262, 159, 265],
    ['c', 172, 261, 184, 255, 198, 252],
    ['c', 200, 252, 203, 252, 205, 251],
    ['c', 210, 250, 216, 248, 222, 247],
    ['c', 226, 246, 231, 246, 234, 245],
    ['c', 237, 244, 240, 242, 242, 240],
    ['c', 246, 237, 250, 231, 254, 227],
    ['c', 257, 223, 260, 219, 262, 216],
    ['c', 263, 214, 263, 212, 264, 210],
    ['c', 264, 208, 265, 206, 266, 205],
    ['c', 267, 197, 266, 187, 266, 178],
    ['c', 267, 172, 268, 165, 273, 164],
    ['l', 276, 163]
  ],
  shark_h: [
    ['m', 281, 77],
    ['c', 289, 79, 295, 83, 301, 88],
    ['c', 302, 88, 302, 89, 302, 89],
    ['c', 306, 93, 309, 99, 313, 104],
    ['c', 321, 115, 327, 124, 335, 135],
    ['c', 336, 137, 338, 140, 341, 142],
    ['c', 343, 144, 346, 148, 348, 149],
    ['c', 350, 149, 353, 150, 355, 150],
    ['c', 357, 151, 359, 152, 361, 153],
    ['c', 362, 153, 364, 153, 365, 153],
    ['c', 368, 154, 370, 154, 374, 155],
    ['c', 381, 156, 389, 158, 397, 159],
    ['c', 403, 160, 408, 160, 414, 162],
    ['c', 422, 164, 431, 165, 439, 167],
    ['c', 444, 169, 448, 169, 453, 170],
    ['c', 456, 170, 457, 171, 460, 172],
    ['c', 462, 173, 464, 173, 467, 173],
    ['c', 497, 181, 526, 188, 556, 199],
    ['c', 559, 200, 562, 201, 565, 202],
    ['c', 574, 205, 584, 208, 592, 212],
    ['c', 598, 213, 604, 216, 610, 219],
    ['c', 615, 221, 623, 223, 623, 230],
    ['c', 622, 235, 615, 239, 611, 240],
    ['c', 608, 242, 605, 243, 602, 244],
    ['c', 600, 245, 597, 246, 594, 247],
    ['c', 589, 248, 585, 247, 581, 248],
    ['c', 576, 249, 572, 251, 567, 251],
    ['c', 568, 253, 568, 256, 567, 257],
    ['c', 566, 259, 562, 259, 560, 260],
    ['c', 557, 261, 556, 262, 554, 263],
    ['c', 547, 265, 537, 265, 527, 266],
    ['c', 523, 267, 518, 268, 514, 268],
    ['c', 509, 268, 504, 268, 500, 269],
    ['c', 497, 269, 495, 270, 493, 271],
    ['c', 470, 273, 447, 273, 426, 273],
    ['c', 423, 277, 421, 282, 417, 286],
    ['c', 415, 288, 412, 289, 411, 291],
    ['c', 409, 293, 408, 296, 406, 297],
    ['c', 402, 301, 397, 305, 393, 307],
    ['c', 390, 308, 383, 311, 378, 309],
    ['c', 375, 308, 375, 305, 375, 301],
    ['c', 367, 310, 358, 317, 349, 324],
    ['c', 348, 326, 346, 327, 345, 328],
    ['c', 339, 335, 330, 340, 322, 346],
    ['c', 319, 348, 316, 350, 313, 352],
    ['c', 310, 355, 307, 357, 303, 359],
    ['c', 298, 361, 292, 363, 286, 364],
    ['c', 286, 364, 285, 364, 284, 364],
    ['c', 277, 360, 286, 350, 288, 345],
    ['c', 292, 339, 297, 331, 300, 323],
    ['c', 307, 315, 311, 303, 317, 294],
    ['c', 320, 284, 326, 278, 328, 266],
    ['c', 310, 267, 293, 263, 276, 262],
    ['c', 271, 262, 268, 262, 264, 261],
    ['c', 261, 261, 258, 259, 254, 259],
    ['c', 251, 258, 247, 259, 244, 258],
    ['c', 241, 257, 238, 255, 235, 255],
    ['c', 231, 260, 229, 267, 220, 267],
    ['c', 214, 264, 213, 257, 209, 252],
    ['c', 204, 251, 200, 249, 195, 250],
    ['c', 193, 250, 192, 252, 190, 252],
    ['c', 186, 253, 181, 253, 176, 255],
    ['c', 175, 256, 174, 257, 172, 258],
    ['c', 170, 259, 167, 259, 165, 260],
    ['c', 161, 262, 157, 265, 152, 262],
    ['c', 153, 259, 157, 258, 159, 256],
    ['c', 162, 254, 163, 251, 165, 248],
    ['c', 166, 244, 168, 241, 169, 237],
    ['c', 165, 237, 164, 235, 162, 236],
    ['c', 157, 238, 157, 249, 154, 253],
    ['c', 151, 257, 145, 262, 143, 254],
    ['c', 142, 249, 144, 244, 143, 240],
    ['c', 141, 234, 138, 230, 136, 226],
    ['c', 133, 235, 134, 249, 130, 257],
    ['c', 126, 263, 124, 273, 114, 272],
    ['c', 113, 267, 115, 261, 115, 256],
    ['c', 116, 250, 116, 243, 117, 238],
    ['c', 117, 234, 119, 230, 119, 227],
    ['c', 118, 223, 113, 216, 111, 212],
    ['c', 104, 196, 98, 180, 87, 168],
    ['c', 83, 168, 78, 171, 76, 168],
    ['c', 75, 165, 77, 162, 77, 160],
    ['c', 77, 158, 75, 154, 74, 153],
    ['c', 71, 149, 65, 148, 64, 142],
    ['c', 64, 141, 64, 140, 64, 139],
    ['c', 65, 135, 69, 137, 73, 137],
    ['c', 75, 138, 77, 140, 80, 141],
    ['c', 98, 159, 118, 175, 135, 195],
    ['c', 139, 191, 142, 184, 142, 177],
    ['c', 142, 173, 139, 163, 143, 162],
    ['c', 148, 161, 152, 168, 154, 170],
    ['c', 157, 174, 159, 177, 163, 180],
    ['c', 176, 176, 188, 170, 202, 168],
    ['c', 204, 167, 206, 167, 209, 166],
    ['c', 214, 165, 220, 163, 227, 162],
    ['c', 230, 161, 235, 161, 239, 160],
    ['c', 241, 159, 245, 157, 247, 155],
    ['c', 250, 152, 255, 146, 259, 142],
    ['c', 262, 138, 265, 134, 267, 130],
    ['c', 267, 129, 268, 126, 268, 124],
    ['c', 269, 122, 270, 121, 270, 120],
    ['c', 272, 111, 271, 101, 271, 92],
    ['c', 272, 86, 273, 79, 278, 77],
    ['l', 281, 77]
  ],
  lion_v: [
    ['m', 487, 138],
    ['c', 488, 136, 488, 133, 489, 131],
    ['c', 491, 132, 491, 134, 493, 136],
    ['c', 494, 133, 492, 129, 493, 127],
    ['c', 497, 127, 498, 131, 500, 134],
    ['c', 502, 132, 503, 129, 505, 127],
    ['c', 510, 127, 508, 133, 511, 134],
    ['c', 512, 134, 511, 131, 512, 131],
    ['c', 516, 132, 515, 138, 517, 142],
    ['c', 519, 142, 519, 139, 521, 139],
    ['c', 522, 138, 522, 139, 522, 140],
    ['c', 525, 140, 525, 137, 528, 137],
    ['c', 529, 139, 527, 141, 526, 142],
    ['c', 526, 145, 525, 148, 526, 152],
    ['c', 526, 152, 527, 153, 527, 154],
    ['c', 530, 150, 535, 146, 541, 147],
    ['c', 542, 150, 540, 151, 539, 153],
    ['c', 540, 155, 542, 157, 543, 159],
    ['c', 548, 158, 550, 166, 546, 169],
    ['c', 549, 170, 550, 168, 553, 168],
    ['c', 554, 169, 554, 170, 554, 171],
    ['c', 555, 172, 556, 172, 556, 173],
    ['c', 557, 176, 552, 178, 553, 181],
    ['c', 553, 181, 551, 181, 551, 182],
    ['c', 553, 185, 558, 187, 560, 192],
    ['c', 560, 193, 560, 194, 561, 196],
    ['c', 562, 200, 565, 203, 564, 209],
    ['c', 564, 210, 564, 210, 562, 211],
    ['c', 565, 213, 565, 218, 567, 221],
    ['c', 568, 228, 567, 237, 564, 243],
    ['c', 565, 246, 563, 248, 562, 250],
    ['c', 562, 251, 563, 253, 562, 254],
    ['c', 562, 256, 561, 258, 560, 260],
    ['c', 559, 260, 558, 260, 557, 260],
    ['c', 556, 261, 554, 260, 553, 263],
    ['c', 553, 263, 552, 262, 551, 262],
    ['c', 548, 266, 548, 275, 545, 280],
    ['c', 544, 280, 543, 279, 542, 279],
    ['c', 537, 281, 538, 287, 538, 294],
    ['c', 534, 298, 532, 304, 525, 304],
    ['c', 524, 306, 524, 309, 523, 311],
    ['c', 523, 312, 522, 313, 520, 312],
    ['c', 519, 317, 522, 323, 520, 328],
    ['c', 522, 334, 520, 342, 515, 344],
    ['c', 515, 347, 515, 350, 513, 353],
    ['c', 513, 353, 512, 354, 511, 355],
    ['c', 511, 356, 511, 357, 511, 357],
    ['c', 510, 358, 508, 360, 507, 361],
    ['c', 505, 365, 505, 368, 499, 369],
    ['c', 500, 371, 500, 373, 501, 374],
    ['c', 502, 376, 503, 378, 504, 379],
    ['c', 506, 382, 508, 385, 509, 389],
    ['c', 511, 392, 513, 394, 515, 397],
    ['c', 517, 401, 518, 404, 520, 406],
    ['c', 529, 415, 536, 426, 543, 436],
    ['c', 544, 435, 546, 435, 548, 435],
    ['c', 551, 433, 554, 432, 557, 432],
    ['c', 559, 432, 560, 433, 561, 434],
    ['c', 562, 434, 563, 434, 564, 434],
    ['c', 567, 435, 569, 438, 571, 440],
    ['c', 574, 441, 577, 443, 578, 447],
    ['c', 576, 448, 574, 447, 572, 447],
    ['c', 563, 447, 552, 450, 542, 449],
    ['c', 539, 449, 537, 449, 534, 449],
    ['c', 528, 449, 520, 450, 519, 445],
    ['c', 515, 445, 512, 445, 509, 443],
    ['c', 508, 442, 508, 440, 506, 439],
    ['c', 504, 432, 500, 427, 495, 423],
    ['c', 491, 420, 487, 417, 483, 415],
    ['c', 478, 411, 471, 408, 467, 402],
    ['c', 462, 398, 457, 392, 452, 387],
    ['c', 451, 388, 449, 387, 447, 386],
    ['c', 446, 388, 442, 389, 440, 391],
    ['c', 439, 391, 439, 390, 438, 390],
    ['c', 437, 393, 432, 394, 431, 391],
    ['c', 429, 393, 425, 394, 422, 392],
    ['c', 421, 392, 419, 393, 419, 392],
    ['c', 415, 396, 412, 401, 409, 406],
    ['c', 406, 411, 402, 415, 399, 421],
    ['c', 398, 421, 398, 422, 397, 423],
    ['c', 396, 428, 394, 433, 392, 438],
    ['c', 397, 439, 406, 445, 400, 451],
    ['c', 393, 454, 382, 455, 372, 454],
    ['c', 365, 454, 360, 453, 357, 450],
    ['c', 356, 446, 360, 444, 361, 441],
    ['c', 366, 431, 366, 418, 367, 405],
    ['c', 368, 402, 369, 399, 369, 396],
    ['c', 370, 393, 370, 390, 370, 388],
    ['c', 371, 386, 372, 384, 372, 382],
    ['c', 373, 380, 372, 378, 374, 377],
    ['c', 372, 376, 371, 376, 369, 376],
    ['c', 361, 377, 353, 379, 344, 378],
    ['c', 338, 378, 332, 376, 327, 375],
    ['c', 320, 374, 314, 372, 309, 369],
    ['c', 305, 368, 301, 369, 297, 368],
    ['c', 297, 368, 296, 367, 295, 366],
    ['c', 293, 366, 290, 365, 288, 365],
    ['c', 287, 364, 287, 363, 286, 363],
    ['c', 283, 362, 282, 362, 280, 361],
    ['c', 277, 362, 279, 365, 278, 369],
    ['c', 278, 372, 277, 375, 276, 377],
    ['c', 275, 382, 274, 386, 273, 390],
    ['c', 269, 398, 264, 406, 265, 417],
    ['c', 266, 422, 269, 426, 272, 430],
    ['c', 273, 432, 276, 434, 278, 436],
    ['c', 279, 435, 281, 436, 283, 436],
    ['c', 284, 436, 286, 435, 287, 435],
    ['c', 291, 434, 295, 438, 298, 439],
    ['c', 300, 440, 302, 440, 303, 441],
    ['c', 306, 442, 310, 448, 308, 452],
    ['c', 304, 453, 300, 456, 296, 456],
    ['c', 288, 457, 279, 455, 271, 455],
    ['c', 268, 454, 265, 455, 262, 454],
    ['c', 259, 453, 254, 449, 251, 448],
    ['c', 246, 445, 244, 444, 241, 440],
    ['c', 239, 437, 237, 434, 235, 431],
    ['c', 232, 428, 229, 424, 227, 420],
    ['c', 226, 418, 225, 416, 225, 414],
    ['c', 225, 411, 228, 408, 229, 404],
    ['c', 229, 401, 229, 398, 228, 395],
    ['c', 221, 399, 217, 405, 209, 411],
    ['c', 203, 416, 197, 420, 189, 424],
    ['c', 184, 427, 180, 429, 175, 432],
    ['c', 173, 433, 170, 435, 168, 436],
    ['c', 167, 437, 167, 438, 166, 439],
    ['c', 164, 441, 160, 442, 159, 445],
    ['c', 161, 448, 168, 453, 163, 457],
    ['c', 157, 458, 151, 457, 144, 457],
    ['c', 139, 458, 133, 458, 128, 457],
    ['c', 126, 457, 123, 456, 123, 454],
    ['c', 123, 452, 126, 450, 127, 449],
    ['c', 129, 446, 128, 443, 129, 440],
    ['c', 131, 436, 133, 430, 134, 425],
    ['c', 135, 423, 135, 421, 136, 419],
    ['c', 136, 418, 138, 417, 140, 416],
    ['c', 148, 410, 156, 404, 161, 395],
    ['c', 162, 392, 162, 389, 162, 385],
    ['c', 163, 379, 165, 376, 167, 371],
    ['c', 176, 353, 184, 334, 196, 319],
    ['c', 197, 317, 195, 315, 194, 313],
    ['c', 194, 309, 197, 309, 199, 306],
    ['c', 195, 305, 192, 305, 188, 305],
    ['c', 187, 305, 186, 306, 184, 306],
    ['c', 178, 307, 173, 309, 167, 312],
    ['c', 162, 313, 158, 315, 154, 316],
    ['c', 152, 317, 148, 318, 146, 320],
    ['c', 134, 325, 123, 331, 113, 338],
    ['c', 109, 340, 105, 342, 102, 345],
    ['c', 99, 348, 95, 350, 92, 353],
    ['c', 90, 354, 89, 357, 87, 360],
    ['c', 85, 363, 81, 367, 80, 371],
    ['c', 78, 379, 81, 385, 85, 390],
    ['c', 87, 393, 91, 394, 94, 397],
    ['c', 102, 401, 108, 407, 114, 412],
    ['c', 116, 416, 118, 419, 118, 423],
    ['c', 118, 426, 117, 428, 116, 431],
    ['c', 116, 432, 116, 433, 116, 434],
    ['c', 115, 434, 114, 434, 114, 435],
    ['c', 113, 437, 113, 438, 112, 440],
    ['c', 108, 441, 108, 448, 105, 449],
    ['c', 102, 449, 100, 447, 99, 446],
    ['c', 97, 442, 96, 435, 98, 430],
    ['c', 98, 428, 99, 426, 100, 425],
    ['c', 101, 422, 103, 420, 102, 417],
    ['c', 98, 413, 94, 408, 88, 406],
    ['c', 86, 404, 83, 403, 81, 401],
    ['c', 79, 400, 79, 399, 77, 397],
    ['c', 76, 395, 74, 394, 73, 393],
    ['c', 71, 389, 69, 384, 69, 379],
    ['c', 68, 374, 70, 366, 72, 361],
    ['c', 74, 357, 78, 351, 81, 347],
    ['c', 82, 346, 84, 345, 85, 344],
    ['c', 86, 343, 87, 341, 88, 340],
    ['c', 90, 338, 93, 336, 95, 334],
    ['c', 97, 332, 99, 330, 102, 328],
    ['c', 103, 328, 104, 327, 105, 327],
    ['c', 107, 326, 108, 324, 110, 323],
    ['c', 112, 321, 115, 320, 117, 319],
    ['c', 119, 317, 121, 316, 123, 314],
    ['c', 129, 311, 135, 307, 141, 304],
    ['c', 147, 301, 154, 298, 160, 295],
    ['c', 163, 293, 166, 293, 169, 292],
    ['c', 174, 290, 179, 287, 185, 285],
    ['c', 190, 283, 196, 282, 201, 280],
    ['c', 204, 280, 206, 280, 209, 279],
    ['c', 211, 278, 213, 278, 215, 278],
    ['c', 217, 277, 220, 274, 222, 273],
    ['c', 225, 272, 228, 271, 231, 270],
    ['c', 237, 268, 243, 266, 251, 266],
    ['c', 257, 265, 263, 266, 269, 265],
    ['c', 271, 264, 275, 263, 277, 264],
    ['c', 288, 264, 297, 262, 308, 261],
    ['c', 315, 260, 322, 258, 328, 257],
    ['c', 341, 257, 354, 257, 366, 257],
    ['c', 372, 256, 377, 256, 381, 254],
    ['c', 383, 253, 385, 252, 387, 251],
    ['c', 389, 250, 391, 250, 393, 250],
    ['c', 397, 247, 399, 244, 402, 240],
    ['c', 403, 240, 403, 240, 404, 240],
    ['c', 405, 239, 404, 238, 405, 238],
    ['c', 406, 238, 407, 238, 408, 238],
    ['c', 409, 236, 410, 235, 410, 233],
    ['c', 412, 232, 413, 231, 413, 229],
    ['c', 414, 228, 413, 228, 413, 227],
    ['c', 414, 224, 416, 224, 417, 223],
    ['c', 418, 221, 418, 220, 418, 218],
    ['c', 419, 216, 421, 214, 421, 212],
    ['c', 421, 211, 422, 210, 423, 209],
    ['c', 424, 208, 422, 208, 422, 206],
    ['c', 424, 204, 424, 201, 427, 200],
    ['c', 428, 195, 430, 191, 432, 188],
    ['c', 432, 187, 432, 187, 432, 186],
    ['c', 435, 184, 437, 181, 441, 181],
    ['c', 440, 178, 442, 174, 443, 171],
    ['c', 445, 169, 446, 167, 448, 166],
    ['c', 448, 165, 447, 164, 447, 163],
    ['c', 449, 162, 452, 162, 453, 162],
    ['c', 453, 160, 454, 159, 455, 159],
    ['c', 456, 157, 453, 158, 453, 156],
    ['c', 457, 156, 458, 153, 461, 154],
    ['c', 462, 152, 462, 151, 464, 150],
    ['c', 465, 148, 468, 149, 469, 147],
    ['c', 470, 147, 470, 147, 471, 147],
    ['c', 472, 143, 479, 144, 480, 148],
    ['c', 482, 145, 484, 140, 486, 138],
    ['c', 486, 138, 486, 137, 487, 138]
  ],
  lion_h: [
    ['m', 495, 70],
    ['c', 496, 68, 495, 65, 496, 63],
    ['c', 498, 64, 499, 66, 500, 68],
    ['c', 501, 66, 499, 61, 501, 59],
    ['c', 504, 60, 505, 64, 507, 66],
    ['c', 509, 64, 510, 61, 512, 59],
    ['c', 516, 59, 515, 65, 517, 66],
    ['c', 518, 66, 517, 63, 518, 63],
    ['c', 522, 64, 522, 70, 523, 74],
    ['c', 525, 73, 525, 71, 527, 70],
    ['c', 528, 70, 528, 71, 528, 72],
    ['c', 531, 72, 531, 69, 533, 69],
    ['c', 535, 71, 533, 72, 532, 74],
    ['c', 532, 77, 531, 79, 531, 83],
    ['c', 532, 83, 533, 84, 533, 85],
    ['c', 536, 82, 540, 77, 546, 79],
    ['c', 547, 81, 545, 83, 544, 84],
    ['c', 545, 86, 547, 88, 548, 90],
    ['c', 553, 89, 555, 97, 551, 99],
    ['c', 554, 101, 555, 98, 557, 99],
    ['c', 559, 99, 558, 100, 559, 101],
    ['c', 559, 102, 560, 102, 560, 103],
    ['c', 561, 106, 557, 108, 557, 111],
    ['c', 557, 111, 556, 111, 556, 111],
    ['c', 557, 115, 562, 117, 564, 121],
    ['c', 564, 122, 564, 124, 565, 125],
    ['c', 566, 129, 569, 131, 568, 137],
    ['c', 568, 138, 568, 139, 566, 139],
    ['c', 569, 141, 569, 146, 571, 149],
    ['c', 572, 155, 571, 164, 568, 169],
    ['c', 569, 172, 567, 174, 566, 177],
    ['c', 566, 178, 566, 179, 566, 181],
    ['c', 566, 182, 565, 184, 564, 186],
    ['c', 563, 186, 562, 186, 561, 186],
    ['c', 560, 187, 558, 186, 558, 188],
    ['c', 557, 189, 556, 188, 556, 188],
    ['c', 552, 192, 553, 200, 550, 205],
    ['c', 549, 205, 548, 204, 547, 204],
    ['c', 542, 206, 543, 212, 543, 218],
    ['c', 540, 222, 538, 228, 530, 228],
    ['c', 530, 230, 530, 233, 529, 235],
    ['c', 529, 235, 528, 236, 526, 236],
    ['c', 526, 241, 528, 246, 526, 251],
    ['c', 528, 257, 526, 264, 521, 266],
    ['c', 521, 269, 521, 272, 520, 274],
    ['c', 519, 275, 518, 276, 518, 276],
    ['c', 517, 277, 518, 278, 517, 278],
    ['c', 517, 279, 515, 281, 514, 282],
    ['c', 512, 286, 511, 289, 506, 290],
    ['c', 507, 292, 507, 293, 508, 295],
    ['c', 509, 296, 510, 298, 511, 299],
    ['c', 512, 302, 514, 305, 516, 308],
    ['c', 517, 311, 520, 314, 521, 317],
    ['c', 523, 320, 524, 323, 526, 325],
    ['c', 534, 334, 541, 344, 548, 354],
    ['c', 549, 353, 551, 352, 553, 352],
    ['c', 555, 351, 558, 349, 561, 350],
    ['c', 563, 350, 564, 351, 565, 351],
    ['c', 566, 351, 567, 351, 568, 351],
    ['c', 571, 353, 573, 356, 574, 357],
    ['c', 578, 358, 580, 360, 581, 364],
    ['c', 579, 365, 578, 364, 575, 364],
    ['c', 567, 364, 557, 366, 547, 366],
    ['c', 544, 366, 542, 366, 540, 366],
    ['c', 534, 366, 526, 367, 525, 362],
    ['c', 521, 362, 518, 362, 516, 361],
    ['c', 514, 359, 514, 357, 513, 356],
    ['c', 510, 350, 507, 345, 502, 341],
    ['c', 498, 339, 495, 336, 491, 333],
    ['c', 486, 330, 480, 327, 476, 321],
    ['c', 470, 317, 466, 311, 461, 307],
    ['c', 460, 308, 458, 307, 457, 306],
    ['c', 455, 308, 452, 308, 450, 311],
    ['c', 449, 311, 449, 310, 448, 310],
    ['c', 447, 312, 443, 313, 441, 311],
    ['c', 439, 313, 435, 314, 433, 311],
    ['c', 432, 311, 430, 312, 430, 311],
    ['c', 426, 316, 423, 320, 420, 325],
    ['c', 417, 329, 413, 334, 411, 339],
    ['c', 410, 340, 410, 340, 409, 341],
    ['c', 408, 346, 406, 350, 404, 355],
    ['c', 409, 357, 418, 362, 412, 368],
    ['c', 405, 371, 395, 371, 385, 371],
    ['c', 379, 371, 374, 370, 371, 367],
    ['c', 370, 363, 373, 361, 375, 358],
    ['c', 379, 348, 380, 336, 381, 324],
    ['c', 381, 321, 382, 318, 382, 316],
    ['c', 383, 313, 383, 310, 383, 308],
    ['c', 384, 306, 385, 304, 386, 302],
    ['c', 386, 300, 386, 298, 387, 297],
    ['c', 386, 297, 384, 296, 382, 297],
    ['c', 375, 298, 367, 299, 359, 299],
    ['c', 353, 298, 348, 296, 342, 296],
    ['c', 336, 294, 330, 292, 326, 290],
    ['c', 322, 289, 318, 290, 314, 289],
    ['c', 313, 288, 313, 288, 312, 287],
    ['c', 310, 286, 307, 286, 305, 286],
    ['c', 304, 285, 304, 284, 303, 284],
    ['c', 301, 283, 299, 283, 298, 282],
    ['c', 295, 283, 296, 286, 296, 290],
    ['c', 295, 292, 295, 295, 294, 298],
    ['c', 293, 302, 291, 306, 291, 310],
    ['c', 287, 317, 283, 325, 284, 336],
    ['c', 284, 340, 287, 344, 290, 347],
    ['c', 291, 350, 294, 351, 296, 354],
    ['c', 297, 353, 299, 354, 300, 353],
    ['c', 302, 353, 303, 352, 304, 352],
    ['c', 308, 352, 312, 355, 315, 356],
    ['c', 317, 357, 318, 357, 319, 358],
    ['c', 322, 360, 326, 365, 324, 369],
    ['c', 321, 370, 317, 372, 313, 373],
    ['c', 306, 374, 297, 372, 289, 371],
    ['c', 286, 371, 283, 371, 281, 370],
    ['c', 278, 369, 273, 366, 270, 365],
    ['c', 265, 362, 263, 361, 260, 357],
    ['c', 258, 355, 256, 352, 255, 349],
    ['c', 252, 345, 249, 342, 247, 338],
    ['c', 246, 337, 245, 334, 245, 332],
    ['c', 246, 329, 248, 327, 249, 323],
    ['c', 249, 320, 249, 318, 248, 314],
    ['c', 241, 318, 237, 324, 230, 330],
    ['c', 225, 335, 218, 338, 211, 342],
    ['c', 207, 345, 202, 347, 198, 350],
    ['c', 195, 351, 193, 352, 191, 354],
    ['c', 190, 354, 190, 355, 189, 356],
    ['c', 187, 358, 183, 359, 182, 362],
    ['c', 185, 365, 191, 370, 186, 374],
    ['c', 181, 375, 175, 374, 168, 374],
    ['c', 163, 374, 158, 374, 153, 374],
    ['c', 151, 374, 149, 372, 148, 371],
    ['c', 148, 369, 151, 367, 152, 365],
    ['c', 154, 363, 153, 360, 154, 357],
    ['c', 156, 354, 158, 348, 159, 343],
    ['c', 159, 341, 159, 339, 160, 338],
    ['c', 161, 337, 163, 336, 164, 335],
    ['c', 171, 329, 179, 323, 184, 315],
    ['c', 185, 311, 185, 309, 185, 305],
    ['c', 186, 299, 188, 296, 190, 292],
    ['c', 198, 274, 206, 256, 217, 242],
    ['c', 218, 240, 216, 238, 216, 236],
    ['c', 216, 233, 219, 232, 220, 230],
    ['c', 217, 229, 214, 228, 210, 229],
    ['c', 209, 229, 208, 230, 207, 230],
    ['c', 200, 231, 195, 233, 190, 235],
    ['c', 186, 237, 182, 238, 178, 240],
    ['c', 175, 241, 172, 242, 170, 243],
    ['c', 159, 247, 148, 254, 138, 260],
    ['c', 135, 262, 131, 264, 128, 267],
    ['c', 125, 270, 122, 272, 119, 274],
    ['c', 117, 276, 116, 279, 114, 281],
    ['c', 112, 284, 108, 288, 107, 292],
    ['c', 105, 299, 108, 305, 112, 310],
    ['c', 114, 313, 118, 314, 120, 317],
    ['c', 128, 321, 134, 326, 140, 331],
    ['c', 141, 334, 144, 337, 144, 341],
    ['c', 143, 344, 142, 346, 142, 349],
    ['c', 141, 349, 141, 350, 141, 351],
    ['c', 141, 352, 140, 352, 139, 353],
    ['c', 138, 354, 138, 356, 137, 357],
    ['c', 133, 358, 134, 365, 131, 365],
    ['c', 128, 366, 126, 364, 126, 363],
    ['c', 123, 360, 122, 352, 124, 347],
    ['c', 125, 346, 125, 344, 126, 343],
    ['c', 127, 340, 129, 339, 128, 335],
    ['c', 124, 331, 121, 327, 115, 325],
    ['c', 113, 323, 110, 322, 108, 321],
    ['c', 107, 320, 106, 318, 104, 316],
    ['c', 103, 315, 102, 314, 101, 312],
    ['c', 99, 309, 97, 304, 96, 299],
    ['c', 96, 294, 98, 287, 100, 282],
    ['c', 102, 278, 105, 273, 108, 269],
    ['c', 109, 268, 111, 267, 112, 266],
    ['c', 113, 265, 114, 263, 114, 262],
    ['c', 117, 260, 119, 258, 122, 256],
    ['c', 124, 254, 125, 252, 128, 251],
    ['c', 129, 250, 130, 250, 131, 250],
    ['c', 133, 248, 134, 247, 136, 246],
    ['c', 138, 244, 140, 243, 142, 242],
    ['c', 144, 241, 146, 239, 148, 238],
    ['c', 154, 234, 159, 231, 165, 228],
    ['c', 171, 225, 177, 222, 183, 219],
    ['c', 186, 218, 189, 217, 192, 216],
    ['c', 197, 215, 202, 212, 207, 210],
    ['c', 212, 208, 218, 207, 223, 205],
    ['c', 225, 205, 227, 205, 230, 204],
    ['c', 232, 203, 234, 203, 236, 203],
    ['c', 238, 202, 241, 200, 243, 198],
    ['c', 245, 197, 248, 196, 251, 195],
    ['c', 257, 194, 262, 192, 270, 191],
    ['c', 275, 191, 282, 192, 287, 191],
    ['c', 289, 190, 292, 188, 295, 190],
    ['c', 305, 190, 314, 188, 324, 187],
    ['c', 331, 186, 337, 184, 343, 183],
    ['c', 355, 183, 368, 183, 380, 183],
    ['c', 385, 182, 390, 182, 394, 180],
    ['c', 396, 180, 397, 178, 399, 177],
    ['c', 401, 177, 403, 177, 405, 176],
    ['c', 409, 174, 411, 171, 414, 167],
    ['c', 415, 167, 415, 167, 416, 167],
    ['c', 416, 166, 416, 165, 416, 165],
    ['c', 418, 165, 419, 165, 419, 165],
    ['c', 420, 163, 421, 162, 421, 160],
    ['c', 423, 160, 424, 158, 425, 157],
    ['c', 425, 156, 424, 155, 424, 154],
    ['c', 425, 152, 427, 152, 428, 150],
    ['c', 429, 149, 429, 148, 429, 146],
    ['c', 430, 144, 432, 142, 431, 140],
    ['c', 432, 139, 433, 138, 434, 137],
    ['c', 434, 136, 433, 136, 433, 135],
    ['c', 435, 133, 435, 130, 437, 128],
    ['c', 438, 124, 440, 121, 443, 117],
    ['c', 443, 117, 443, 116, 443, 115],
    ['c', 445, 114, 447, 111, 451, 111],
    ['c', 450, 108, 451, 104, 453, 101],
    ['c', 455, 100, 456, 98, 457, 97],
    ['c', 457, 95, 456, 95, 457, 93],
    ['c', 458, 92, 461, 93, 462, 92],
    ['c', 462, 91, 463, 90, 465, 90],
    ['c', 465, 88, 462, 89, 462, 87],
    ['c', 466, 87, 467, 84, 470, 85],
    ['c', 471, 83, 471, 82, 472, 81],
    ['c', 474, 80, 476, 80, 477, 78],
    ['c', 478, 78, 479, 78, 479, 78],
    ['c', 481, 75, 487, 75, 488, 79],
    ['c', 490, 77, 491, 72, 493, 70],
    ['c', 494, 70, 494, 69, 495, 70]
  ],
  cammel_v: [
    ['m', 575, 421],
    ['c', 575, 422, 575, 423, 575, 424],
    ['c', 572, 427, 572, 432, 570, 436],
    ['c', 569, 439, 566, 440, 565, 442],
    ['c', 564, 444, 565, 446, 564, 448],
    ['c', 562, 454, 558, 459, 556, 465],
    ['c', 553, 473, 550, 482, 547, 489],
    ['c', 543, 497, 545, 507, 541, 515],
    ['c', 540, 518, 536, 524, 534, 526],
    ['c', 530, 530, 523, 530, 517, 531],
    ['c', 515, 531, 512, 531, 509, 531],
    ['c', 504, 529, 496, 530, 492, 527],
    ['c', 491, 526, 489, 523, 489, 522],
    ['c', 489, 517, 497, 517, 500, 513],
    ['c', 503, 512, 508, 511, 511, 509],
    ['c', 524, 503, 530, 478, 531, 458],
    ['c', 532, 448, 531, 436, 529, 428],
    ['c', 528, 423, 526, 418, 524, 414],
    ['c', 522, 410, 518, 406, 517, 402],
    ['c', 515, 394, 512, 386, 511, 378],
    ['c', 510, 364, 513, 354, 503, 348],
    ['c', 497, 352, 498, 358, 495, 364],
    ['c', 493, 372, 486, 380, 486, 389],
    ['c', 485, 396, 485, 405, 486, 413],
    ['c', 487, 429, 496, 446, 484, 455],
    ['c', 482, 456, 480, 456, 478, 458],
    ['c', 475, 460, 473, 464, 470, 469],
    ['c', 467, 472, 463, 475, 460, 478],
    ['c', 459, 480, 459, 482, 458, 483],
    ['c', 456, 485, 454, 485, 452, 487],
    ['c', 442, 495, 441, 509, 433, 520],
    ['c', 426, 530, 405, 526, 388, 524],
    ['c', 386, 521, 383, 519, 384, 514],
    ['c', 390, 505, 400, 508, 410, 503],
    ['c', 414, 501, 419, 496, 423, 491],
    ['c', 427, 487, 429, 481, 432, 476],
    ['c', 437, 467, 442, 461, 443, 447],
    ['c', 444, 442, 447, 436, 446, 432],
    ['c', 446, 428, 444, 424, 442, 420],
    ['c', 441, 416, 439, 412, 439, 408],
    ['c', 437, 394, 439, 381, 437, 367],
    ['c', 437, 366, 436, 364, 435, 362],
    ['c', 434, 358, 436, 355, 432, 353],
    ['c', 430, 353, 430, 355, 428, 354],
    ['c', 426, 353, 426, 349, 423, 349],
    ['c', 421, 350, 421, 354, 419, 355],
    ['c', 415, 356, 414, 353, 413, 351],
    ['c', 411, 351, 409, 353, 407, 351],
    ['c', 405, 351, 406, 355, 405, 356],
    ['c', 400, 355, 394, 351, 391, 355],
    ['c', 390, 355, 389, 354, 387, 353],
    ['c', 385, 354, 385, 355, 383, 356],
    ['c', 380, 356, 378, 353, 376, 354],
    ['c', 373, 354, 372, 359, 368, 357],
    ['c', 366, 359, 368, 363, 365, 363],
    ['c', 363, 361, 362, 358, 358, 357],
    ['c', 356, 359, 353, 361, 348, 361],
    ['c', 346, 361, 347, 365, 346, 366],
    ['c', 343, 366, 343, 365, 340, 365],
    ['c', 338, 365, 338, 369, 337, 370],
    ['c', 334, 370, 332, 371, 330, 372],
    ['c', 329, 374, 331, 375, 330, 377],
    ['c', 327, 377, 327, 375, 325, 375],
    ['c', 323, 378, 323, 383, 317, 383],
    ['c', 315, 386, 314, 390, 312, 393],
    ['c', 309, 399, 305, 401, 307, 411],
    ['c', 307, 414, 308, 416, 309, 418],
    ['c', 310, 425, 307, 433, 304, 441],
    ['c', 304, 444, 303, 449, 304, 453],
    ['c', 304, 460, 306, 467, 307, 475],
    ['c', 309, 482, 312, 489, 313, 495],
    ['c', 313, 499, 312, 503, 312, 506],
    ['c', 313, 511, 316, 516, 311, 520],
    ['c', 295, 521, 277, 523, 262, 520],
    ['c', 262, 514, 258, 512, 258, 507],
    ['c', 259, 499, 268, 496, 273, 491],
    ['c', 278, 480, 281, 467, 279, 451],
    ['c', 277, 440, 265, 435, 265, 424],
    ['c', 260, 421, 258, 416, 251, 417],
    ['c', 249, 412, 243, 411, 239, 409],
    ['c', 238, 407, 238, 406, 237, 404],
    ['c', 236, 404, 232, 406, 232, 406],
    ['c', 232, 406, 231, 403, 232, 402],
    ['c', 232, 401, 234, 400, 234, 400],
    ['c', 233, 399, 231, 399, 231, 398],
    ['c', 230, 398, 232, 396, 231, 395],
    ['c', 230, 395, 231, 396, 230, 395],
    ['c', 230, 395, 225, 396, 225, 396],
    ['c', 225, 396, 224, 394, 225, 393],
    ['c', 225, 392, 226, 391, 226, 391],
    ['c', 225, 390, 225, 389, 225, 387],
    ['c', 221, 388, 215, 384, 213, 387],
    ['c', 211, 387, 212, 384, 209, 384],
    ['c', 207, 385, 209, 388, 207, 389],
    ['c', 205, 390, 204, 388, 203, 388],
    ['c', 202, 390, 198, 391, 196, 393],
    ['c', 195, 393, 195, 391, 194, 391],
    ['c', 192, 392, 193, 395, 190, 395],
    ['c', 188, 394, 188, 392, 188, 389],
    ['c', 183, 392, 178, 386, 172, 391],
    ['c', 170, 391, 172, 388, 170, 388],
    ['c', 166, 387, 167, 392, 163, 392],
    ['c', 162, 389, 165, 383, 163, 381],
    ['c', 160, 379, 160, 384, 157, 383],
    ['c', 156, 382, 156, 379, 156, 377],
    ['c', 153, 376, 151, 377, 147, 378],
    ['c', 147, 374, 150, 373, 150, 369],
    ['c', 148, 368, 146, 370, 145, 368],
    ['c', 143, 368, 144, 365, 143, 364],
    ['c', 142, 363, 141, 363, 139, 363],
    ['c', 138, 360, 136, 358, 137, 354],
    ['c', 135, 352, 132, 351, 132, 347],
    ['c', 130, 347, 129, 349, 127, 348],
    ['c', 126, 346, 128, 341, 127, 339],
    ['c', 125, 338, 125, 340, 123, 340],
    ['c', 122, 338, 122, 335, 121, 334],
    ['c', 119, 333, 118, 334, 116, 334],
    ['c', 114, 332, 115, 328, 113, 326],
    ['c', 111, 325, 109, 325, 107, 324],
    ['c', 106, 320, 108, 315, 107, 310],
    ['c', 107, 308, 104, 309, 103, 307],
    ['c', 104, 303, 104, 298, 105, 294],
    ['c', 105, 292, 102, 291, 102, 289],
    ['c', 102, 286, 105, 284, 105, 281],
    ['c', 105, 279, 102, 277, 102, 275],
    ['c', 102, 271, 105, 269, 106, 265],
    ['c', 108, 262, 108, 256, 109, 251],
    ['c', 110, 246, 112, 241, 111, 237],
    ['c', 110, 234, 107, 233, 104, 231],
    ['c', 102, 229, 100, 226, 97, 225],
    ['c', 93, 223, 88, 223, 83, 222],
    ['c', 77, 218, 77, 210, 81, 204],
    ['c', 80, 201, 78, 200, 76, 198],
    ['c', 75, 198, 75, 198, 75, 197],
    ['c', 75, 197, 74, 196, 74, 196],
    ['c', 74, 195, 74, 194, 74, 193],
    ['c', 74, 193, 74, 192, 74, 192],
    ['c', 74, 192, 75, 192, 75, 192],
    ['c', 76, 189, 78, 183, 79, 179],
    ['c', 80, 177, 81, 176, 81, 176],
    ['c', 81, 176, 81, 176, 81, 176],
    ['c', 81, 176, 81, 175, 81, 175],
    ['c', 81, 175, 81, 175, 83, 173],
    ['c', 89, 169, 104, 160, 118, 161],
    ['c', 119, 154, 121, 147, 126, 142],
    ['c', 131, 138, 137, 137, 142, 133],
    ['c', 144, 136, 149, 134, 152, 136],
    ['c', 155, 134, 155, 131, 159, 130],
    ['c', 161, 131, 159, 135, 160, 137],
    ['c', 163, 137, 163, 135, 166, 135],
    ['c', 167, 136, 167, 138, 168, 139],
    ['c', 175, 140, 181, 142, 189, 142],
    ['c', 190, 143, 189, 145, 190, 146],
    ['c', 192, 146, 194, 147, 195, 147],
    ['c', 196, 149, 197, 151, 197, 154],
    ['c', 200, 155, 202, 156, 201, 160],
    ['c', 203, 160, 205, 158, 206, 160],
    ['c', 207, 164, 205, 165, 205, 169],
    ['c', 207, 171, 212, 170, 213, 173],
    ['c', 213, 181, 218, 186, 216, 193],
    ['c', 219, 194, 220, 190, 222, 189],
    ['c', 224, 185, 224, 182, 225, 178],
    ['c', 227, 169, 234, 165, 239, 158],
    ['c', 241, 156, 243, 151, 244, 148],
    ['c', 245, 144, 248, 140, 248, 136],
    ['c', 248, 129, 244, 124, 245, 118],
    ['c', 246, 115, 248, 112, 247, 107],
    ['c', 249, 105, 249, 101, 254, 102],
    ['c', 255, 100, 255, 98, 258, 97],
    ['c', 259, 96, 261, 98, 262, 97],
    ['c', 266, 96, 267, 91, 270, 91],
    ['c', 271, 90, 273, 91, 275, 91],
    ['c', 280, 91, 284, 87, 289, 89],
    ['c', 291, 89, 291, 87, 293, 87],
    ['c', 298, 90, 304, 88, 308, 91],
    ['c', 309, 91, 311, 90, 312, 90],
    ['c', 316, 93, 317, 97, 322, 97],
    ['c', 322, 101, 326, 101, 327, 103],
    ['c', 323, 108, 327, 116, 330, 121],
    ['c', 329, 122, 329, 126, 329, 129],
    ['c', 333, 133, 336, 139, 339, 145],
    ['c', 340, 140, 338, 136, 338, 132],
    ['c', 338, 127, 340, 122, 339, 118],
    ['c', 339, 114, 336, 111, 338, 108],
    ['c', 339, 106, 341, 108, 343, 106],
    ['c', 343, 104, 344, 103, 343, 101],
    ['c', 345, 99, 348, 97, 351, 96],
    ['c', 352, 95, 352, 91, 354, 91],
    ['c', 356, 90, 359, 93, 360, 92],
    ['c', 364, 91, 368, 89, 370, 85],
    ['c', 372, 85, 374, 85, 374, 85],
    ['c', 374, 85, 375, 82, 377, 81],
    ['c', 379, 82, 381, 79, 383, 79],
    ['c', 386, 78, 389, 79, 392, 79],
    ['c', 397, 80, 402, 79, 406, 79],
    ['c', 408, 80, 407, 83, 409, 83],
    ['c', 411, 83, 413, 82, 415, 82],
    ['c', 420, 88, 426, 94, 430, 102],
    ['c', 436, 103, 438, 107, 443, 108],
    ['c', 445, 114, 452, 114, 456, 117],
    ['c', 460, 119, 465, 124, 468, 128],
    ['c', 471, 134, 472, 142, 475, 149],
    ['c', 476, 151, 478, 153, 478, 155],
    ['c', 480, 159, 480, 165, 482, 169],
    ['c', 485, 174, 490, 177, 494, 182],
    ['c', 495, 183, 495, 185, 496, 186],
    ['c', 500, 190, 505, 193, 509, 196],
    ['c', 522, 206, 533, 218, 543, 230],
    ['c', 546, 237, 550, 244, 551, 253],
    ['c', 552, 262, 554, 273, 554, 283],
    ['c', 555, 294, 554, 304, 555, 314],
    ['c', 555, 317, 557, 320, 557, 324],
    ['c', 558, 333, 556, 344, 558, 351],
    ['c', 560, 355, 566, 356, 568, 361],
    ['c', 568, 361, 569, 364, 569, 364],
    ['c', 569, 364, 568, 365, 568, 366],
    ['c', 565, 367, 566, 371, 566, 371],
    ['c', 566, 371, 562, 373, 560, 374],
    ['c', 560, 394, 567, 408, 575, 421]
  ],
  cammel_h: [
    ['m', 554, 309],
    ['c', 554, 310, 554, 311, 554, 312],
    ['c', 552, 314, 552, 318, 550, 321],
    ['c', 549, 323, 547, 324, 547, 326],
    ['c', 546, 327, 546, 329, 545, 331],
    ['c', 544, 335, 541, 339, 539, 344],
    ['c', 537, 351, 535, 357, 532, 363],
    ['c', 529, 370, 531, 377, 528, 384],
    ['c', 527, 386, 524, 391, 522, 392],
    ['c', 519, 395, 513, 395, 509, 396],
    ['c', 507, 396, 504, 396, 502, 396],
    ['c', 498, 395, 492, 395, 489, 393],
    ['c', 488, 393, 486, 390, 486, 389],
    ['c', 486, 385, 493, 385, 495, 382],
    ['c', 498, 382, 502, 381, 504, 379],
    ['c', 514, 374, 519, 354, 520, 338],
    ['c', 520, 330, 519, 321, 518, 314],
    ['c', 517, 311, 515, 307, 514, 303],
    ['c', 512, 300, 510, 298, 508, 294],
    ['c', 507, 288, 504, 281, 504, 275],
    ['c', 503, 264, 505, 256, 497, 251],
    ['c', 493, 254, 493, 259, 491, 264],
    ['c', 489, 271, 484, 277, 484, 284],
    ['c', 483, 290, 483, 297, 484, 303],
    ['c', 485, 315, 492, 329, 482, 336],
    ['c', 481, 337, 479, 337, 478, 338],
    ['c', 475, 340, 474, 343, 471, 347],
    ['c', 469, 350, 465, 352, 464, 354],
    ['c', 463, 356, 462, 357, 461, 358],
    ['c', 460, 359, 459, 360, 457, 361],
    ['c', 449, 368, 448, 379, 442, 388],
    ['c', 436, 396, 420, 392, 406, 391],
    ['c', 404, 389, 403, 387, 403, 382],
    ['c', 408, 376, 416, 378, 424, 374],
    ['c', 427, 373, 431, 368, 434, 365],
    ['c', 437, 361, 439, 357, 441, 353],
    ['c', 445, 345, 449, 341, 450, 330],
    ['c', 451, 326, 453, 321, 453, 318],
    ['c', 452, 315, 450, 312, 449, 308],
    ['c', 448, 305, 447, 302, 447, 299],
    ['c', 445, 288, 447, 278, 445, 267],
    ['c', 445, 266, 444, 264, 444, 263],
    ['c', 443, 259, 444, 257, 441, 256],
    ['c', 439, 255, 439, 257, 438, 256],
    ['c', 436, 255, 436, 253, 434, 252],
    ['c', 432, 253, 433, 256, 431, 257],
    ['c', 427, 258, 427, 255, 426, 254],
    ['c', 424, 254, 423, 255, 422, 254],
    ['c', 420, 254, 421, 257, 419, 258],
    ['c', 416, 257, 411, 254, 409, 257],
    ['c', 408, 257, 407, 256, 406, 256],
    ['c', 404, 256, 404, 257, 402, 258],
    ['c', 400, 258, 398, 256, 397, 256],
    ['c', 394, 256, 394, 260, 390, 259],
    ['c', 389, 260, 390, 263, 389, 264],
    ['c', 387, 262, 386, 259, 382, 259],
    ['c', 381, 260, 379, 262, 375, 261],
    ['c', 373, 262, 374, 265, 373, 266],
    ['c', 371, 266, 370, 265, 369, 265],
    ['c', 366, 265, 367, 268, 366, 269],
    ['c', 363, 269, 362, 270, 360, 271],
    ['c', 360, 272, 361, 273, 360, 274],
    ['c', 358, 275, 358, 273, 356, 273],
    ['c', 355, 275, 355, 279, 350, 279],
    ['c', 349, 282, 348, 284, 347, 287],
    ['c', 344, 292, 341, 293, 342, 302],
    ['c', 342, 303, 343, 305, 344, 307],
    ['c', 344, 313, 342, 319, 340, 325],
    ['c', 340, 327, 339, 331, 340, 334],
    ['c', 340, 340, 342, 346, 343, 352],
    ['c', 343, 358, 346, 363, 347, 368],
    ['c', 347, 371, 346, 374, 347, 377],
    ['c', 347, 380, 349, 384, 345, 387],
    ['c', 333, 388, 319, 390, 306, 388],
    ['c', 307, 383, 303, 381, 304, 377],
    ['c', 304, 371, 312, 368, 315, 364],
    ['c', 319, 356, 322, 345, 320, 333],
    ['c', 318, 324, 309, 320, 309, 312],
    ['c', 305, 309, 304, 305, 298, 306],
    ['c', 297, 302, 292, 301, 288, 300],
    ['c', 288, 298, 287, 297, 287, 296],
    ['c', 286, 296, 283, 297, 283, 297],
    ['c', 283, 297, 282, 295, 283, 294],
    ['c', 283, 293, 284, 293, 284, 292],
    ['c', 284, 292, 282, 292, 282, 291],
    ['c', 282, 291, 283, 289, 282, 289],
    ['c', 282, 288, 282, 289, 282, 289],
    ['c', 281, 288, 277, 289, 277, 289],
    ['c', 277, 289, 277, 288, 277, 287],
    ['c', 277, 286, 278, 285, 278, 285],
    ['c', 278, 284, 277, 284, 277, 282],
    ['c', 274, 283, 270, 280, 268, 282],
    ['c', 266, 282, 267, 280, 265, 280],
    ['c', 263, 280, 264, 283, 263, 284],
    ['c', 262, 285, 261, 283, 260, 283],
    ['c', 259, 285, 256, 285, 255, 287],
    ['c', 253, 287, 254, 286, 253, 286],
    ['c', 251, 286, 252, 288, 250, 288],
    ['c', 248, 288, 248, 286, 248, 284],
    ['c', 244, 287, 240, 282, 236, 285],
    ['c', 234, 285, 235, 283, 234, 283],
    ['c', 231, 283, 232, 286, 229, 286],
    ['c', 228, 284, 230, 279, 228, 277],
    ['c', 226, 276, 226, 280, 223, 279],
    ['c', 223, 278, 223, 276, 223, 275],
    ['c', 220, 274, 219, 274, 216, 275],
    ['c', 216, 272, 218, 271, 218, 268],
    ['c', 216, 267, 215, 269, 214, 267],
    ['c', 213, 267, 213, 265, 213, 264],
    ['c', 212, 263, 211, 263, 209, 263],
    ['c', 208, 261, 207, 259, 208, 256],
    ['c', 206, 255, 204, 253, 204, 251],
    ['c', 202, 251, 201, 252, 200, 251],
    ['c', 199, 250, 200, 246, 199, 245],
    ['c', 198, 244, 198, 245, 196, 245],
    ['c', 196, 244, 196, 241, 195, 240],
    ['c', 193, 239, 193, 240, 191, 240],
    ['c', 190, 239, 190, 236, 188, 234],
    ['c', 187, 234, 185, 233, 184, 232],
    ['c', 183, 229, 185, 225, 184, 222],
    ['c', 184, 220, 181, 220, 181, 219],
    ['c', 182, 216, 182, 212, 183, 209],
    ['c', 182, 208, 180, 207, 180, 205],
    ['c', 180, 203, 183, 201, 182, 198],
    ['c', 182, 197, 180, 195, 180, 193],
    ['c', 180, 191, 182, 189, 183, 186],
    ['c', 184, 183, 185, 179, 186, 175],
    ['c', 187, 171, 188, 167, 187, 164],
    ['c', 187, 161, 184, 160, 182, 159],
    ['c', 180, 157, 179, 155, 176, 154],
    ['c', 173, 152, 169, 153, 165, 151],
    ['c', 160, 148, 160, 142, 164, 138],
    ['c', 163, 135, 161, 134, 159, 133],
    ['c', 159, 133, 159, 132, 159, 132],
    ['c', 158, 132, 158, 131, 158, 131],
    ['c', 158, 130, 158, 129, 158, 129],
    ['c', 158, 128, 158, 128, 158, 128],
    ['c', 158, 128, 158, 128, 158, 128],
    ['c', 160, 125, 161, 121, 162, 117],
    ['c', 163, 116, 163, 116, 163, 115],
    ['c', 163, 115, 163, 115, 163, 115],
    ['c', 163, 115, 163, 115, 163, 115],
    ['c', 164, 115, 164, 114, 165, 113],
    ['c', 170, 110, 182, 103, 192, 104],
    ['c', 193, 98, 195, 92, 199, 88],
    ['c', 203, 85, 208, 85, 212, 82],
    ['c', 213, 84, 217, 82, 219, 84],
    ['c', 222, 83, 222, 80, 225, 79],
    ['c', 226, 80, 225, 83, 226, 84],
    ['c', 228, 84, 228, 83, 230, 83],
    ['c', 232, 83, 231, 85, 232, 86],
    ['c', 238, 87, 243, 88, 249, 88],
    ['c', 250, 89, 249, 91, 250, 92],
    ['c', 251, 92, 253, 92, 254, 93],
    ['c', 254, 94, 255, 96, 255, 98],
    ['c', 257, 99, 259, 100, 258, 103],
    ['c', 260, 103, 262, 101, 262, 103],
    ['c', 263, 106, 261, 107, 261, 110],
    ['c', 263, 111, 267, 111, 268, 113],
    ['c', 268, 119, 272, 123, 270, 129],
    ['c', 272, 130, 273, 127, 275, 126],
    ['c', 276, 123, 276, 120, 277, 117],
    ['c', 279, 110, 285, 107, 288, 101],
    ['c', 290, 99, 291, 96, 292, 93],
    ['c', 294, 90, 295, 87, 295, 84],
    ['c', 295, 79, 292, 75, 293, 69],
    ['c', 294, 67, 296, 65, 295, 61],
    ['c', 296, 59, 296, 56, 300, 57],
    ['c', 301, 56, 301, 54, 303, 53],
    ['c', 304, 52, 306, 53, 307, 53],
    ['c', 309, 52, 311, 48, 313, 48],
    ['c', 314, 48, 316, 48, 317, 48],
    ['c', 321, 48, 324, 45, 328, 46],
    ['c', 329, 46, 330, 45, 332, 45],
    ['c', 335, 47, 340, 46, 343, 48],
    ['c', 344, 48, 345, 48, 346, 48],
    ['c', 349, 49, 350, 53, 354, 53],
    ['c', 354, 56, 357, 56, 358, 57],
    ['c', 355, 62, 358, 68, 360, 72],
    ['c', 359, 73, 360, 76, 360, 78],
    ['c', 363, 82, 365, 86, 368, 91],
    ['c', 368, 87, 367, 84, 367, 80],
    ['c', 367, 77, 368, 73, 368, 69],
    ['c', 367, 66, 365, 64, 367, 61],
    ['c', 368, 60, 370, 62, 370, 60],
    ['c', 370, 59, 371, 58, 371, 56],
    ['c', 373, 54, 375, 53, 377, 52],
    ['c', 378, 52, 378, 48, 379, 48],
    ['c', 381, 47, 383, 50, 384, 49],
    ['c', 388, 48, 391, 46, 392, 44],
    ['c', 393, 44, 395, 44, 395, 44],
    ['c', 395, 44, 396, 41, 397, 40],
    ['c', 399, 41, 401, 39, 403, 38],
    ['c', 405, 38, 407, 39, 409, 39],
    ['c', 413, 39, 417, 39, 421, 39],
    ['c', 422, 39, 421, 41, 423, 41],
    ['c', 425, 42, 426, 41, 428, 41],
    ['c', 432, 46, 436, 51, 439, 57],
    ['c', 444, 57, 446, 61, 450, 61],
    ['c', 452, 66, 457, 66, 460, 69],
    ['c', 464, 70, 468, 74, 469, 77],
    ['c', 472, 82, 473, 88, 475, 94],
    ['c', 476, 96, 477, 97, 478, 99],
    ['c', 479, 102, 479, 106, 481, 110],
    ['c', 483, 114, 487, 116, 490, 120],
    ['c', 491, 121, 491, 122, 492, 123],
    ['c', 495, 126, 499, 128, 502, 131],
    ['c', 512, 139, 521, 148, 529, 158],
    ['c', 531, 164, 535, 169, 536, 176],
    ['c', 536, 183, 537, 192, 538, 200],
    ['c', 539, 208, 538, 217, 538, 224],
    ['c', 538, 227, 540, 230, 540, 232],
    ['c', 541, 240, 539, 248, 541, 254],
    ['c', 542, 257, 547, 258, 549, 262],
    ['c', 549, 262, 550, 264, 550, 264],
    ['c', 550, 264, 549, 265, 549, 265],
    ['c', 547, 266, 547, 270, 547, 270],
    ['c', 547, 270, 544, 271, 542, 272],
    ['c', 543, 288, 548, 299, 554, 309]
  ],
  bird1_h: [
    ['m', 157, 23],
    ['c', 162, 32, 167, 41, 171, 50],
    ['c', 173, 54, 175, 56, 177, 60],
    ['c', 179, 63, 181, 66, 183, 70],
    ['c', 188, 76, 192, 82, 197, 87],
    ['c', 199, 90, 201, 94, 205, 95],
    ['c', 200, 87, 191, 77, 187, 64],
    ['c', 186, 62, 186, 59, 185, 56],
    ['c', 183, 51, 180, 46, 180, 40],
    ['c', 179, 36, 179, 29, 180, 24],
    ['c', 182, 25, 183, 29, 184, 31],
    ['c', 187, 40, 190, 52, 194, 61],
    ['c', 197, 68, 200, 74, 204, 79],
    ['c', 205, 82, 208, 85, 210, 88],
    ['c', 213, 94, 215, 99, 220, 102],
    ['c', 214, 91, 206, 71, 205, 54],
    ['c', 204, 51, 204, 47, 206, 45],
    ['c', 209, 48, 210, 54, 211, 58],
    ['c', 218, 82, 226, 106, 239, 119],
    ['c', 240, 120, 241, 119, 242, 119],
    ['c', 252, 130, 264, 141, 275, 153],
    ['c', 279, 157, 283, 160, 286, 163],
    ['c', 290, 167, 292, 171, 295, 175],
    ['c', 298, 179, 302, 182, 305, 185],
    ['c', 307, 188, 308, 190, 310, 192],
    ['c', 315, 196, 321, 201, 325, 206],
    ['c', 329, 210, 332, 215, 336, 219],
    ['c', 340, 223, 344, 227, 348, 231],
    ['c', 350, 233, 355, 234, 359, 236],
    ['c', 363, 237, 367, 240, 370, 240],
    ['c', 377, 242, 382, 239, 390, 235],
    ['c', 393, 233, 397, 229, 401, 228],
    ['c', 406, 225, 415, 224, 418, 227],
    ['c', 423, 227, 429, 227, 432, 231],
    ['c', 433, 232, 433, 235, 434, 237],
    ['c', 434, 240, 433, 240, 434, 242],
    ['c', 431, 243, 427, 242, 425, 244],
    ['c', 424, 245, 423, 246, 422, 247],
    ['c', 421, 248, 419, 249, 417, 250],
    ['c', 411, 255, 409, 262, 405, 267],
    ['c', 408, 269, 411, 271, 415, 272],
    ['c', 416, 272, 417, 272, 418, 272],
    ['c', 422, 273, 427, 274, 432, 275],
    ['c', 433, 276, 433, 277, 434, 277],
    ['c', 435, 277, 436, 277, 438, 277],
    ['c', 441, 278, 444, 280, 448, 282],
    ['c', 452, 283, 455, 284, 459, 285],
    ['c', 462, 286, 466, 288, 470, 289],
    ['c', 473, 290, 478, 290, 481, 291],
    ['c', 483, 292, 486, 293, 488, 294],
    ['c', 490, 295, 493, 296, 495, 296],
    ['c', 501, 298, 507, 300, 513, 300],
    ['c', 514, 300, 520, 297, 520, 301],
    ['c', 520, 302, 517, 303, 515, 304],
    ['c', 518, 305, 522, 305, 526, 306],
    ['c', 531, 307, 535, 309, 542, 306],
    ['c', 547, 305, 554, 299, 556, 296],
    ['c', 558, 293, 558, 288, 561, 286],
    ['c', 568, 285, 569, 279, 572, 275],
    ['c', 577, 275, 577, 272, 580, 271],
    ['c', 582, 273, 580, 275, 579, 277],
    ['c', 577, 282, 575, 288, 572, 293],
    ['c', 570, 297, 563, 302, 559, 306],
    ['c', 555, 308, 551, 311, 547, 313],
    ['c', 543, 314, 539, 315, 535, 316],
    ['c', 531, 317, 525, 316, 522, 319],
    ['c', 523, 323, 527, 321, 529, 324],
    ['c', 522, 326, 513, 324, 506, 325],
    ['c', 506, 329, 512, 333, 511, 337],
    ['c', 504, 338, 499, 334, 493, 332],
    ['c', 493, 341, 480, 337, 476, 337],
    ['c', 474, 338, 469, 342, 465, 343],
    ['c', 463, 343, 461, 342, 460, 342],
    ['c', 458, 342, 458, 344, 456, 344],
    ['c', 452, 346, 444, 347, 444, 342],
    ['c', 442, 343, 443, 345, 441, 346],
    ['c', 437, 349, 431, 349, 428, 348],
    ['c', 421, 349, 413, 351, 408, 349],
    ['c', 401, 352, 396, 351, 391, 350],
    ['c', 390, 349, 388, 349, 387, 349],
    ['c', 386, 348, 385, 347, 384, 347],
    ['c', 381, 346, 378, 347, 376, 344],
    ['c', 371, 345, 369, 344, 367, 341],
    ['c', 366, 341, 365, 342, 364, 342],
    ['c', 359, 340, 354, 339, 348, 340],
    ['c', 346, 336, 342, 335, 338, 336],
    ['c', 336, 331, 342, 328, 345, 325],
    ['c', 342, 327, 331, 333, 328, 328],
    ['c', 321, 332, 313, 335, 307, 338],
    ['c', 306, 342, 303, 345, 302, 349],
    ['c', 298, 356, 295, 361, 290, 369],
    ['c', 288, 371, 286, 377, 284, 378],
    ['c', 281, 379, 277, 377, 275, 376],
    ['c', 271, 378, 266, 380, 264, 377],
    ['c', 262, 379, 257, 380, 254, 380],
    ['c', 253, 381, 253, 379, 252, 379],
    ['c', 248, 380, 239, 384, 237, 380],
    ['c', 234, 382, 231, 381, 229, 380],
    ['c', 226, 380, 224, 381, 222, 379],
    ['c', 222, 377, 222, 376, 222, 374],
    ['c', 219, 376, 215, 371, 220, 370],
    ['c', 217, 369, 213, 368, 213, 363],
    ['c', 212, 362, 211, 362, 210, 361],
    ['c', 209, 356, 213, 354, 215, 350],
    ['c', 213, 349, 210, 349, 209, 347],
    ['c', 207, 343, 212, 340, 214, 337],
    ['c', 212, 335, 208, 334, 207, 331],
    ['c', 207, 329, 211, 328, 212, 326],
    ['c', 209, 324, 207, 322, 205, 319],
    ['c', 208, 316, 213, 316, 217, 315],
    ['c', 233, 313, 252, 308, 268, 305],
    ['c', 274, 303, 280, 302, 281, 298],
    ['c', 281, 297, 280, 297, 280, 296],
    ['c', 273, 299, 266, 300, 265, 293],
    ['c', 264, 291, 266, 289, 266, 287],
    ['c', 265, 286, 262, 285, 262, 282],
    ['c', 261, 282, 262, 285, 260, 285],
    ['c', 258, 284, 257, 283, 256, 280],
    ['c', 250, 282, 247, 274, 249, 270],
    ['c', 243, 274, 235, 271, 236, 264],
    ['c', 232, 263, 228, 262, 228, 257],
    ['c', 226, 255, 223, 256, 221, 253],
    ['c', 220, 252, 220, 250, 218, 249],
    ['c', 217, 247, 214, 247, 213, 246],
    ['c', 212, 245, 212, 244, 212, 244],
    ['c', 210, 241, 207, 241, 206, 240],
    ['c', 204, 236, 206, 233, 207, 230],
    ['c', 205, 229, 204, 227, 202, 226],
    ['c', 199, 226, 196, 227, 194, 226],
    ['c', 193, 223, 185, 222, 190, 218],
    ['c', 186, 218, 184, 214, 182, 212],
    ['c', 181, 210, 183, 209, 182, 208],
    ['c', 179, 205, 171, 203, 174, 197],
    ['c', 171, 194, 169, 192, 167, 190],
    ['c', 167, 187, 168, 185, 169, 183],
    ['c', 167, 181, 163, 178, 165, 174],
    ['c', 161, 173, 153, 168, 157, 162],
    ['c', 153, 159, 145, 157, 148, 150],
    ['c', 149, 149, 152, 149, 154, 147],
    ['c', 152, 145, 146, 145, 143, 142],
    ['c', 141, 140, 138, 138, 138, 134],
    ['c', 138, 131, 142, 128, 147, 129],
    ['c', 147, 126, 144, 126, 142, 125],
    ['c', 138, 122, 133, 117, 130, 112],
    ['c', 135, 107, 140, 113, 145, 112],
    ['c', 142, 109, 138, 105, 134, 103],
    ['c', 130, 98, 123, 97, 121, 91],
    ['c', 128, 92, 135, 95, 142, 98],
    ['c', 149, 101, 156, 103, 162, 106],
    ['c', 162, 102, 157, 100, 154, 98],
    ['c', 148, 93, 142, 89, 137, 83],
    ['c', 131, 77, 125, 73, 122, 63],
    ['c', 125, 63, 126, 65, 128, 67],
    ['c', 144, 77, 159, 89, 175, 98],
    ['c', 174, 93, 169, 90, 165, 85],
    ['c', 155, 76, 145, 66, 139, 52],
    ['c', 137, 49, 136, 45, 136, 41],
    ['c', 140, 42, 141, 47, 144, 48],
    ['c', 151, 59, 160, 66, 168, 76],
    ['c', 175, 82, 181, 89, 189, 94],
    ['c', 188, 89, 184, 87, 182, 83],
    ['c', 171, 69, 156, 47, 156, 24],
    ['c', 156, 24, 157, 23, 157, 23],
    ['c', 157, 23, 157, 23, 157, 23],
    ['l', 157, 23],
    ['z'],
    ['m', 419, 240],
    ['l', 419, 240],
    ['c', 424, 240, 429, 239, 433, 240],
    ['c', 431, 235, 421, 236, 419, 240]
  ],
  bird1_v: [
    ['m', 150, 61],
    ['c', 152, 74, 155, 87, 158, 100],
    ['c', 158, 105, 160, 109, 162, 114],
    ['c', 164, 119, 165, 124, 166, 128],
    ['c', 170, 138, 173, 147, 177, 156],
    ['c', 179, 160, 180, 165, 185, 167],
    ['c', 182, 156, 174, 141, 173, 123],
    ['c', 172, 120, 173, 116, 173, 113],
    ['c', 172, 105, 170, 97, 172, 90],
    ['c', 173, 85, 175, 76, 178, 70],
    ['c', 180, 72, 179, 77, 180, 81],
    ['c', 181, 92, 181, 108, 183, 122],
    ['c', 184, 131, 186, 140, 188, 148],
    ['c', 189, 152, 192, 156, 193, 161],
    ['c', 195, 169, 196, 177, 201, 183],
    ['c', 197, 166, 194, 138, 198, 117],
    ['c', 199, 112, 200, 107, 204, 105],
    ['c', 206, 111, 205, 118, 205, 124],
    ['c', 205, 156, 207, 188, 219, 210],
    ['c', 220, 211, 222, 211, 223, 212],
    ['c', 232, 229, 243, 247, 253, 265],
    ['c', 256, 271, 260, 276, 263, 282],
    ['c', 266, 288, 267, 294, 270, 300],
    ['c', 273, 305, 276, 311, 279, 316],
    ['c', 280, 320, 281, 323, 283, 326],
    ['c', 287, 332, 293, 341, 297, 348],
    ['c', 300, 355, 303, 362, 306, 369],
    ['c', 310, 375, 313, 382, 317, 388],
    ['c', 319, 391, 324, 395, 329, 398],
    ['c', 334, 401, 337, 405, 342, 408],
    ['c', 349, 411, 357, 410, 368, 407],
    ['c', 373, 406, 379, 403, 385, 402],
    ['c', 392, 402, 403, 403, 406, 408],
    ['c', 413, 409, 420, 411, 422, 417],
    ['c', 423, 419, 422, 423, 423, 426],
    ['c', 422, 429, 420, 429, 421, 432],
    ['c', 417, 432, 412, 430, 409, 431],
    ['c', 407, 431, 406, 433, 404, 434],
    ['c', 402, 435, 399, 435, 397, 436],
    ['c', 388, 440, 382, 448, 375, 454],
    ['c', 379, 457, 382, 460, 386, 463],
    ['c', 387, 463, 389, 463, 390, 464],
    ['c', 395, 467, 401, 469, 407, 473],
    ['c', 408, 474, 408, 475, 409, 476],
    ['c', 410, 476, 412, 476, 413, 477],
    ['c', 417, 480, 421, 483, 425, 486],
    ['c', 429, 489, 433, 492, 437, 495],
    ['c', 441, 497, 445, 501, 449, 503],
    ['c', 454, 505, 459, 507, 463, 510],
    ['c', 466, 511, 468, 514, 470, 516],
    ['c', 473, 518, 476, 519, 479, 521],
    ['c', 485, 525, 492, 530, 499, 532],
    ['c', 501, 532, 509, 531, 508, 535],
    ['c', 508, 538, 504, 537, 501, 537],
    ['c', 504, 540, 509, 541, 514, 543],
    ['c', 521, 547, 524, 551, 534, 550],
    ['c', 541, 550, 551, 545, 555, 542],
    ['c', 559, 539, 560, 533, 565, 532],
    ['c', 574, 532, 577, 525, 583, 522],
    ['c', 588, 523, 589, 519, 594, 519],
    ['c', 596, 522, 593, 524, 591, 526],
    ['c', 586, 532, 582, 538, 576, 543],
    ['c', 572, 548, 562, 553, 555, 555],
    ['c', 550, 557, 543, 559, 538, 560],
    ['c', 533, 560, 527, 560, 522, 560],
    ['c', 517, 559, 510, 556, 504, 559],
    ['c', 504, 564, 510, 563, 512, 567],
    ['c', 502, 568, 492, 562, 483, 561],
    ['c', 480, 566, 487, 573, 485, 578],
    ['c', 475, 576, 470, 570, 463, 565],
    ['c', 461, 577, 446, 568, 440, 565],
    ['c', 438, 566, 430, 570, 424, 569],
    ['c', 422, 569, 420, 567, 418, 567],
    ['c', 417, 566, 415, 568, 413, 568],
    ['c', 407, 569, 398, 567, 399, 561],
    ['c', 396, 561, 396, 564, 393, 565],
    ['c', 388, 567, 380, 565, 377, 563],
    ['c', 367, 562, 357, 562, 351, 557],
    ['c', 342, 558, 335, 556, 330, 552],
    ['c', 328, 551, 326, 550, 324, 549],
    ['c', 323, 548, 323, 546, 321, 545],
    ['c', 318, 543, 314, 543, 312, 539],
    ['c', 306, 540, 304, 537, 302, 533],
    ['c', 301, 532, 300, 534, 298, 533],
    ['c', 293, 528, 286, 526, 279, 524],
    ['c', 277, 520, 273, 517, 267, 516],
    ['c', 267, 509, 276, 508, 281, 506],
    ['c', 276, 506, 260, 510, 258, 503],
    ['c', 248, 505, 237, 506, 227, 508],
    ['c', 225, 513, 221, 516, 218, 520],
    ['c', 211, 528, 205, 533, 196, 541],
    ['c', 193, 543, 189, 549, 185, 550],
    ['c', 181, 550, 177, 547, 175, 545],
    ['c', 169, 545, 163, 546, 161, 542],
    ['c', 157, 543, 151, 544, 147, 543],
    ['c', 145, 543, 145, 541, 145, 540],
    ['c', 140, 540, 127, 542, 126, 537],
    ['c', 121, 538, 118, 536, 116, 534],
    ['c', 113, 533, 109, 533, 107, 530],
    ['c', 108, 528, 109, 526, 109, 524],
    ['c', 105, 526, 102, 518, 108, 518],
    ['c', 104, 516, 100, 513, 102, 507],
    ['c', 101, 505, 99, 505, 98, 503],
    ['c', 99, 497, 105, 495, 108, 491],
    ['c', 106, 489, 103, 488, 102, 485],
    ['c', 101, 479, 108, 478, 111, 475],
    ['c', 110, 472, 105, 469, 105, 465],
    ['c', 106, 462, 111, 462, 113, 460],
    ['c', 110, 457, 108, 454, 107, 449],
    ['c', 112, 446, 118, 448, 124, 448],
    ['c', 144, 451, 169, 452, 191, 453],
    ['c', 199, 453, 206, 454, 209, 449],
    ['c', 209, 448, 208, 448, 208, 446],
    ['c', 199, 447, 189, 446, 191, 437],
    ['c', 191, 435, 194, 433, 194, 431],
    ['c', 194, 428, 190, 426, 192, 423],
    ['c', 190, 422, 190, 426, 188, 426],
    ['c', 186, 424, 185, 421, 184, 418],
    ['c', 177, 418, 175, 407, 180, 402],
    ['c', 170, 406, 162, 400, 164, 390],
    ['c', 160, 388, 155, 385, 157, 379],
    ['c', 155, 376, 151, 376, 149, 372],
    ['c', 148, 371, 149, 368, 148, 366],
    ['c', 147, 363, 143, 362, 142, 360],
    ['c', 141, 359, 142, 358, 142, 357],
    ['c', 140, 353, 136, 352, 135, 349],
    ['c', 134, 345, 138, 342, 140, 338],
    ['c', 138, 336, 137, 333, 135, 331],
    ['c', 132, 330, 128, 330, 125, 329],
    ['c', 125, 324, 115, 320, 123, 317],
    ['c', 118, 316, 117, 311, 115, 306],
    ['c', 115, 304, 117, 304, 117, 301],
    ['c', 114, 297, 104, 291, 110, 285],
    ['c', 108, 281, 105, 277, 103, 274],
    ['c', 104, 270, 107, 268, 109, 266],
    ['c', 107, 262, 103, 258, 106, 253],
    ['c', 102, 250, 94, 242, 101, 235],
    ['c', 97, 231, 87, 225, 94, 217],
    ['c', 96, 216, 100, 217, 102, 216],
    ['c', 101, 212, 93, 210, 91, 205],
    ['c', 89, 202, 86, 199, 87, 194],
    ['c', 88, 190, 94, 187, 99, 190],
    ['c', 101, 187, 97, 185, 96, 183],
    ['c', 91, 178, 86, 171, 85, 163],
    ['c', 93, 159, 97, 168, 104, 169],
    ['c', 101, 164, 98, 157, 93, 153],
    ['c', 90, 146, 81, 142, 80, 134],
    ['c', 89, 138, 97, 144, 104, 150],
    ['c', 112, 156, 120, 161, 127, 167],
    ['c', 129, 162, 123, 158, 120, 154],
    ['c', 114, 146, 108, 138, 103, 129],
    ['c', 98, 120, 91, 112, 92, 99],
    ['c', 95, 100, 96, 103, 98, 106],
    ['c', 114, 124, 128, 144, 146, 162],
    ['c', 146, 154, 141, 149, 137, 142],
    ['c', 129, 127, 119, 110, 116, 90],
    ['c', 116, 86, 115, 81, 117, 76],
    ['c', 121, 78, 121, 85, 124, 88],
    ['c', 130, 104, 138, 117, 145, 132],
    ['c', 151, 141, 157, 152, 165, 161],
    ['c', 165, 155, 162, 150, 160, 145],
    ['c', 151, 124, 140, 91, 148, 62],
    ['c', 148, 61, 149, 61, 149, 61],
    ['c', 149, 61, 150, 61, 150, 61],
    ['l', 150, 61],
    ['z'],
    ['m', 403, 425],
    ['l', 403, 425],
    ['c', 409, 425, 416, 426, 420, 429],
    ['c', 420, 422, 407, 420, 403, 425],
    ['z'],
    ['m', 453, 430],
    ['c', 449, 428, 444, 427, 438, 426],
    ['c', 441, 423, 453, 424, 453, 430]
  ],
  dog1_v: [
    ['m', 423, 222],
    ['c', 423, 222, 389, 259, 384, 266],
    ['c', 378, 273, 352, 289, 313, 290],
    ['c', 274, 292, 232, 288, 208, 294],
    ['c', 183, 300, 171, 317, 152, 322],
    ['c', 133, 327, 75, 319, 66, 318],
    ['c', 57, 317, 54, 325, 61, 328],
    ['c', 69, 332, 128, 348, 146, 348],
    ['c', 146, 348, 145, 355, 139, 361],
    ['c', 132, 366, 125, 406, 119, 419],
    ['c', 113, 432, 107, 453, 107, 457],
    ['c', 107, 461, 98, 484, 92, 492],
    ['c', 86, 500, 86, 506, 86, 515],
    ['c', 86, 525, 74, 563, 74, 563],
    ['c', 74, 563, 69, 578, 70, 584],
    ['c', 70, 591, 71, 598, 77, 598],
    ['c', 77, 598, 77, 604, 83, 604],
    ['c', 88, 604, 89, 600, 89, 600],
    ['c', 89, 600, 93, 603, 95, 600],
    ['c', 97, 598, 96, 597, 96, 597],
    ['c', 96, 597, 100, 601, 103, 593],
    ['c', 105, 585, 99, 582, 99, 571],
    ['c', 99, 559, 107, 527, 111, 520],
    ['c', 115, 512, 137, 485, 145, 477],
    ['c', 152, 469, 188, 426, 191, 425],
    ['c', 191, 425, 205, 441, 190, 465],
    ['c', 190, 465, 183, 474, 184, 480],
    ['c', 184, 486, 180, 520, 180, 530],
    ['c', 180, 541, 196, 564, 204, 566],
    ['c', 212, 568, 217, 563, 217, 563],
    ['c', 217, 563, 221, 562, 219, 558],
    ['c', 218, 553, 209, 540, 207, 537],
    ['c', 205, 534, 204, 516, 203, 511],
    ['c', 202, 506, 207, 489, 211, 484],
    ['c', 216, 480, 220, 479, 220, 479],
    ['c', 220, 479, 225, 480, 229, 473],
    ['c', 233, 466, 247, 439, 247, 439],
    ['c', 247, 439, 307, 461, 332, 464],
    ['c', 332, 464, 328, 530, 325, 545],
    ['c', 322, 560, 321, 569, 324, 578],
    ['c', 324, 578, 320, 618, 323, 622],
    ['c', 326, 626, 339, 637, 344, 637],
    ['c', 349, 637, 348, 632, 348, 632],
    ['c', 348, 631, 350, 636, 355, 636],
    ['c', 359, 635, 358, 633, 357, 630],
    ['c', 357, 630, 359, 634, 363, 633],
    ['c', 366, 632, 365, 625, 363, 623],
    ['c', 362, 621, 355, 608, 354, 601],
    ['c', 354, 595, 355, 563, 356, 555],
    ['c', 357, 546, 363, 518, 366, 510],
    ['c', 368, 502, 386, 469, 389, 468],
    ['c', 392, 467, 412, 466, 412, 466],
    ['c', 412, 466, 419, 465, 428, 473],
    ['c', 428, 473, 425, 526, 421, 539],
    ['c', 418, 553, 419, 566, 421, 577],
    ['c', 423, 588, 424, 605, 425, 608],
    ['c', 427, 611, 434, 613, 436, 613],
    ['c', 438, 613, 441, 615, 444, 613],
    ['c', 444, 613, 455, 617, 458, 613],
    ['c', 458, 613, 463, 614, 464, 610],
    ['c', 464, 610, 468, 610, 469, 609],
    ['c', 469, 608, 473, 607, 456, 590],
    ['c', 440, 573, 445, 559, 445, 551],
    ['c', 446, 543, 450, 512, 454, 503],
    ['c', 458, 495, 468, 473, 469, 460],
    ['c', 469, 447, 474, 427, 477, 416],
    ['c', 480, 404, 483, 356, 483, 350],
    ['c', 483, 344, 483, 306, 496, 297],
    ['c', 508, 288, 523, 291, 537, 300],
    ['c', 550, 308, 574, 317, 579, 315],
    ['c', 585, 314, 607, 300, 612, 297],
    ['c', 617, 293, 619, 282, 603, 260],
    ['c', 586, 239, 575, 220, 571, 210],
    ['c', 568, 200, 538, 178, 531, 177],
    ['c', 531, 177, 538, 156, 540, 152],
    ['c', 541, 148, 546, 130, 546, 127],
    ['c', 546, 125, 541, 124, 535, 132],
    ['c', 529, 139, 510, 164, 508, 164],
    ['c', 506, 164, 506, 152, 508, 141],
    ['c', 509, 131, 510, 115, 504, 115],
    ['c', 499, 115, 495, 132, 488, 141],
    ['c', 482, 150, 469, 171, 465, 186],
    ['c', 465, 186, 431, 213, 423, 222]
  ],
  dog1_h: [
    ['m', 407, 93],
    ['c', 407, 93, 382, 120, 378, 125],
    ['c', 374, 130, 355, 142, 326, 143],
    ['c', 298, 144, 267, 141, 249, 145],
    ['c', 231, 150, 222, 162, 208, 166],
    ['c', 194, 170, 152, 164, 145, 163],
    ['c', 139, 162, 136, 168, 142, 171],
    ['c', 147, 173, 191, 185, 204, 185],
    ['c', 204, 185, 203, 190, 198, 194],
    ['c', 193, 198, 188, 228, 184, 237],
    ['c', 180, 246, 175, 262, 175, 265],
    ['c', 175, 268, 169, 285, 164, 291],
    ['c', 160, 296, 160, 301, 160, 308],
    ['c', 160, 315, 151, 343, 151, 343],
    ['c', 151, 343, 147, 354, 148, 358],
    ['c', 148, 363, 149, 368, 153, 368],
    ['c', 153, 368, 153, 373, 157, 373],
    ['c', 161, 373, 162, 370, 162, 370],
    ['c', 162, 370, 165, 372, 167, 370],
    ['c', 168, 368, 167, 368, 167, 368],
    ['c', 167, 368, 170, 370, 172, 365],
    ['c', 173, 359, 169, 357, 169, 348],
    ['c', 169, 340, 175, 316, 178, 311],
    ['c', 181, 305, 197, 285, 203, 280],
    ['c', 208, 274, 235, 243, 237, 242],
    ['c', 237, 242, 247, 253, 236, 271],
    ['c', 236, 271, 231, 277, 231, 282],
    ['c', 232, 286, 229, 311, 229, 319],
    ['c', 229, 326, 240, 344, 246, 345],
    ['c', 252, 347, 256, 342, 256, 342],
    ['c', 256, 342, 259, 342, 258, 339],
    ['c', 257, 335, 250, 326, 249, 324],
    ['c', 247, 322, 246, 308, 246, 304],
    ['c', 245, 301, 249, 288, 252, 285],
    ['c', 255, 282, 258, 281, 258, 281],
    ['c', 258, 281, 262, 282, 265, 277],
    ['c', 267, 272, 278, 252, 278, 252],
    ['c', 278, 252, 322, 268, 340, 270],
    ['c', 340, 270, 337, 318, 335, 330],
    ['c', 333, 341, 332, 347, 334, 354],
    ['c', 334, 354, 332, 383, 334, 386],
    ['c', 336, 389, 345, 397, 349, 397],
    ['c', 353, 397, 352, 394, 352, 393],
    ['c', 352, 393, 354, 396, 357, 396],
    ['c', 360, 396, 359, 394, 359, 392],
    ['c', 359, 392, 360, 395, 363, 394],
    ['c', 365, 394, 364, 388, 363, 387],
    ['c', 362, 385, 357, 375, 357, 371],
    ['c', 356, 366, 357, 343, 358, 337],
    ['c', 359, 330, 363, 310, 365, 304],
    ['c', 367, 298, 380, 274, 382, 273],
    ['c', 384, 272, 399, 271, 399, 271],
    ['c', 399, 271, 404, 271, 411, 277],
    ['c', 411, 277, 409, 316, 406, 325],
    ['c', 403, 335, 404, 345, 406, 353],
    ['c', 407, 361, 408, 373, 409, 376],
    ['c', 410, 378, 415, 380, 417, 380],
    ['c', 418, 380, 420, 381, 422, 380],
    ['c', 422, 380, 431, 382, 432, 379],
    ['c', 432, 379, 436, 380, 437, 377],
    ['c', 437, 377, 440, 377, 440, 377],
    ['c', 441, 376, 443, 375, 431, 362],
    ['c', 419, 350, 423, 340, 423, 334],
    ['c', 424, 328, 427, 305, 430, 299],
    ['c', 433, 293, 440, 277, 440, 267],
    ['c', 441, 258, 444, 243, 446, 235],
    ['c', 449, 226, 451, 191, 451, 186],
    ['c', 451, 182, 451, 154, 460, 148],
    ['c', 469, 141, 481, 143, 490, 150],
    ['c', 500, 156, 518, 162, 522, 161],
    ['c', 526, 160, 542, 150, 545, 147],
    ['c', 549, 144, 551, 137, 539, 121],
    ['c', 526, 105, 518, 91, 516, 84],
    ['c', 513, 77, 491, 60, 486, 59],
    ['c', 486, 59, 492, 44, 493, 41],
    ['c', 494, 38, 497, 25, 497, 23],
    ['c', 497, 22, 494, 21, 489, 26],
    ['c', 485, 32, 471, 50, 469, 50],
    ['c', 468, 50, 468, 41, 469, 34],
    ['c', 470, 26, 471, 14, 467, 14],
    ['c', 462, 14, 460, 27, 455, 33],
    ['c', 450, 40, 440, 55, 437, 66],
    ['c', 437, 66, 413, 86, 407, 93]
  ],
  dog2_v: [
    ['m', 532, 96],
    ['c', 523, 86, 457, 133, 442, 177],
    ['c', 442, 177, 409, 152, 363, 175],
    ['c', 317, 198, 320, 209, 320, 209],
    ['c', 320, 209, 232, 159, 207, 180],
    ['c', 207, 180, 206, 197, 218, 213],
    ['c', 230, 230, 266, 279, 274, 283],
    ['c', 281, 288, 314, 289, 314, 289],
    ['c', 314, 289, 325, 289, 333, 311],
    ['c', 341, 333, 352, 336, 361, 342],
    ['c', 369, 349, 367, 355, 367, 355],
    ['c', 367, 355, 371, 372, 367, 380],
    ['c', 363, 387, 351, 392, 344, 408],
    ['c', 336, 425, 289, 447, 270, 470],
    ['c', 251, 494, 228, 517, 215, 541],
    ['c', 203, 565, 187, 582, 182, 592],
    ['c', 177, 601, 158, 652, 184, 686],
    ['c', 184, 686, 191, 699, 176, 700],
    ['c', 160, 702, 127, 712, 122, 714],
    ['l', 122, 720],
    ['l', 196, 722],
    ['c', 196, 722, 200, 728, 207, 728],
    ['c', 213, 728, 239, 726, 240, 724],
    ['c', 240, 723, 243, 721, 239, 714],
    ['c', 236, 707, 231, 702, 231, 702],
    ['c', 231, 702, 266, 697, 270, 694],
    ['c', 270, 694, 255, 711, 259, 715],
    ['c', 262, 720, 353, 719, 353, 719],
    ['c', 353, 719, 348, 740, 358, 740],
    ['c', 369, 740, 403, 742, 408, 740],
    ['c', 413, 737, 412, 725, 410, 724],
    ['c', 407, 722, 392, 715, 391, 706],
    ['c', 391, 697, 391, 613, 387, 605],
    ['c', 387, 605, 427, 570, 430, 565],
    ['c', 430, 565, 435, 634, 435, 649],
    ['c', 436, 664, 442, 720, 448, 725],
    ['c', 453, 730, 505, 731, 509, 725],
    ['c', 514, 719, 496, 701, 483, 702],
    ['c', 469, 702, 470, 690, 470, 678],
    ['c', 470, 665, 476, 544, 477, 529],
    ['c', 478, 514, 495, 495, 501, 481],
    ['c', 508, 467, 494, 433, 482, 392],
    ['c', 471, 351, 483, 318, 484, 309],
    ['c', 485, 299, 492, 245, 492, 245],
    ['c', 492, 245, 515, 229, 520, 222],
    ['c', 525, 215, 529, 182, 532, 173],
    ['c', 535, 163, 541, 106, 532, 96],
    ['z'],
    ['m', 353, 690],
    ['c', 344, 691, 336, 701, 336, 701],
    ['c', 336, 701, 294, 691, 303, 688],
    ['c', 312, 684, 353, 654, 353, 654],
    ['l', 353, 690]
  ],
  dog2_h: [
    ['m', 418, 41],
    ['c', 413, 36, 379, 60, 372, 83],
    ['c', 372, 83, 355, 70, 332, 82],
    ['c', 308, 94, 309, 99, 309, 99],
    ['c', 309, 99, 264, 73, 252, 84],
    ['c', 252, 84, 251, 93, 257, 101],
    ['c', 263, 110, 282, 135, 286, 137],
    ['c', 290, 140, 306, 140, 306, 140],
    ['c', 306, 140, 312, 140, 316, 151],
    ['c', 320, 162, 326, 164, 330, 167],
    ['c', 335, 170, 333, 174, 333, 174],
    ['c', 333, 174, 335, 182, 333, 186],
    ['c', 331, 190, 325, 192, 322, 201],
    ['c', 318, 209, 293, 220, 284, 232],
    ['c', 274, 244, 262, 256, 256, 269],
    ['c', 250, 281, 242, 290, 239, 295],
    ['c', 236, 300, 226, 325, 240, 343],
    ['c', 240, 343, 244, 349, 236, 350],
    ['c', 228, 351, 211, 356, 208, 357],
    ['l', 208, 360],
    ['l', 246, 361],
    ['c', 246, 361, 248, 364, 252, 364],
    ['c', 255, 364, 268, 363, 268, 362],
    ['c', 269, 362, 270, 361, 268, 357],
    ['c', 267, 354, 264, 351, 264, 351],
    ['c', 264, 351, 282, 348, 284, 347],
    ['c', 284, 347, 276, 355, 278, 358],
    ['c', 280, 360, 326, 360, 326, 360],
    ['c', 326, 360, 324, 370, 329, 370],
    ['c', 334, 370, 352, 372, 354, 370],
    ['c', 357, 369, 357, 363, 355, 362],
    ['c', 354, 361, 346, 357, 346, 353],
    ['c', 346, 348, 346, 305, 344, 301],
    ['c', 344, 301, 364, 283, 366, 281],
    ['c', 366, 281, 368, 316, 368, 324],
    ['c', 369, 332, 372, 360, 375, 363],
    ['c', 378, 365, 404, 366, 406, 363],
    ['c', 408, 360, 400, 351, 392, 351],
    ['c', 385, 351, 386, 345, 386, 338],
    ['c', 386, 332, 389, 270, 390, 263],
    ['c', 390, 255, 399, 245, 402, 238],
    ['c', 405, 231, 398, 213, 392, 193],
    ['c', 386, 172, 392, 155, 393, 150],
    ['c', 394, 145, 397, 118, 397, 118],
    ['c', 397, 118, 409, 109, 412, 106],
    ['c', 414, 102, 416, 85, 418, 80],
    ['c', 419, 76, 422, 46, 418, 41],
    ['z'],
    ['m', 326, 345],
    ['c', 322, 345, 318, 350, 318, 350],
    ['c', 318, 350, 296, 345, 301, 344],
    ['c', 306, 342, 326, 327, 326, 327],
    ['l', 326, 345]
  ],
  rabbit_v: [
    ['m', 418, 111],
    ['c', 418, 106, 419, 101, 419, 95],
    ['c', 420, 85, 422, 82, 432, 80],
    ['c', 441, 78, 444, 79, 449, 88],
    ['c', 464, 115, 475, 144, 482, 175],
    ['c', 484, 185, 484, 195, 484, 206],
    ['c', 484, 212, 487, 214, 493, 214],
    ['c', 514, 216, 532, 223, 543, 243],
    ['c', 551, 258, 563, 271, 568, 287],
    ['c', 569, 290, 573, 293, 575, 295],
    ['c', 588, 305, 589, 318, 581, 332],
    ['c', 567, 357, 545, 365, 519, 366],
    ['c', 513, 367, 509, 370, 507, 375],
    ['c', 504, 380, 506, 384, 509, 387],
    ['c', 515, 394, 517, 402, 516, 410],
    ['c', 515, 421, 514, 432, 509, 443],
    ['c', 506, 447, 506, 453, 506, 459],
    ['c', 505, 464, 505, 469, 504, 474],
    ['c', 502, 488, 494, 498, 479, 500],
    ['c', 471, 502, 462, 505, 460, 514],
    ['c', 458, 525, 464, 532, 473, 537],
    ['c', 481, 542, 489, 548, 497, 553],
    ['c', 500, 555, 504, 557, 506, 560],
    ['c', 511, 566, 510, 574, 502, 576],
    ['c', 474, 582, 446, 589, 421, 568],
    ['c', 413, 562, 405, 558, 397, 553],
    ['c', 394, 551, 390, 548, 388, 545],
    ['c', 384, 539, 378, 538, 372, 540],
    ['c', 368, 541, 365, 542, 361, 544],
    ['c', 353, 548, 345, 551, 336, 551],
    ['c', 326, 551, 325, 555, 331, 563],
    ['c', 333, 566, 335, 569, 337, 572],
    ['c', 341, 577, 340, 581, 335, 585],
    ['c', 330, 591, 323, 593, 315, 593],
    ['c', 291, 592, 266, 591, 241, 589],
    ['c', 225, 588, 210, 586, 194, 584],
    ['c', 188, 583, 181, 581, 176, 578],
    ['c', 164, 573, 152, 572, 140, 572],
    ['c', 134, 572, 127, 570, 122, 568],
    ['c', 104, 560, 92, 545, 80, 530],
    ['c', 75, 524, 78, 520, 83, 516],
    ['c', 87, 512, 88, 508, 87, 503],
    ['c', 84, 493, 88, 485, 92, 477],
    ['c', 95, 472, 99, 475, 103, 477],
    ['c', 106, 479, 109, 481, 113, 483],
    ['c', 114, 479, 115, 474, 115, 470],
    ['c', 114, 443, 116, 416, 123, 390],
    ['c', 126, 383, 130, 376, 134, 370],
    ['c', 154, 346, 176, 327, 201, 309],
    ['c', 217, 299, 235, 295, 253, 293],
    ['c', 276, 289, 299, 290, 322, 298],
    ['c', 329, 300, 335, 303, 341, 307],
    ['c', 347, 311, 352, 310, 357, 305],
    ['c', 362, 301, 368, 294, 374, 292],
    ['c', 388, 289, 389, 279, 389, 268],
    ['c', 390, 255, 390, 242, 390, 229],
    ['c', 391, 220, 388, 213, 382, 206],
    ['c', 357, 179, 344, 149, 349, 112],
    ['c', 350, 102, 350, 93, 350, 84],
    ['c', 351, 75, 355, 70, 364, 70],
    ['c', 375, 68, 385, 73, 392, 82],
    ['c', 398, 88, 402, 96, 407, 103],
    ['c', 410, 106, 412, 109, 415, 112],
    ['c', 416, 111, 417, 111, 418, 111]
  ],
  rabbit_h: [
    ['m', 397, 65],
    ['c', 398, 62, 398, 58, 398, 55],
    ['c', 399, 48, 400, 46, 407, 44],
    ['c', 413, 43, 415, 44, 418, 50],
    ['c', 429, 68, 436, 88, 441, 109],
    ['c', 442, 116, 442, 123, 442, 130],
    ['c', 442, 134, 444, 135, 448, 136],
    ['c', 463, 137, 475, 141, 482, 155],
    ['c', 488, 165, 496, 174, 499, 185],
    ['c', 500, 187, 502, 189, 504, 191],
    ['c', 513, 197, 513, 206, 508, 215],
    ['c', 499, 233, 484, 238, 466, 239],
    ['c', 462, 239, 459, 241, 458, 245],
    ['c', 456, 248, 457, 251, 459, 253],
    ['c', 463, 258, 464, 263, 464, 269],
    ['c', 463, 276, 463, 284, 459, 291],
    ['c', 457, 294, 457, 298, 457, 302],
    ['c', 456, 305, 457, 308, 456, 312],
    ['c', 454, 321, 449, 328, 439, 330],
    ['c', 433, 331, 428, 333, 426, 339],
    ['c', 425, 347, 429, 351, 434, 355],
    ['c', 440, 358, 446, 362, 451, 366],
    ['c', 453, 367, 455, 368, 457, 370],
    ['c', 461, 375, 460, 380, 454, 381],
    ['c', 436, 386, 417, 390, 399, 376],
    ['c', 394, 372, 388, 369, 383, 365],
    ['c', 381, 364, 379, 362, 377, 360],
    ['c', 374, 356, 371, 355, 366, 357],
    ['c', 364, 357, 361, 358, 359, 359],
    ['c', 353, 362, 348, 364, 342, 364],
    ['c', 335, 364, 334, 367, 338, 373],
    ['c', 339, 375, 341, 377, 342, 379],
    ['c', 345, 382, 344, 385, 341, 388],
    ['c', 337, 391, 333, 393, 328, 393],
    ['c', 311, 392, 294, 391, 277, 390],
    ['c', 266, 389, 256, 388, 246, 387],
    ['c', 241, 386, 237, 385, 233, 383],
    ['c', 225, 379, 217, 379, 209, 378],
    ['c', 205, 378, 200, 377, 196, 376],
    ['c', 184, 370, 176, 360, 168, 350],
    ['c', 165, 346, 167, 343, 170, 341],
    ['c', 173, 338, 173, 335, 172, 331],
    ['c', 170, 325, 173, 319, 176, 314],
    ['c', 178, 311, 181, 313, 183, 314],
    ['c', 186, 316, 188, 317, 190, 318],
    ['c', 191, 315, 192, 312, 191, 309],
    ['c', 191, 291, 192, 272, 197, 255],
    ['c', 199, 250, 201, 245, 205, 241],
    ['c', 218, 225, 233, 212, 250, 200],
    ['c', 261, 193, 273, 191, 285, 189],
    ['c', 301, 187, 317, 187, 332, 192],
    ['c', 337, 194, 341, 196, 345, 198],
    ['c', 349, 201, 352, 201, 356, 197],
    ['c', 360, 194, 363, 190, 368, 189],
    ['c', 377, 186, 377, 180, 378, 172],
    ['c', 378, 163, 379, 154, 379, 145],
    ['c', 379, 140, 377, 134, 373, 130],
    ['c', 356, 112, 347, 91, 351, 66],
    ['c', 351, 60, 351, 53, 351, 47],
    ['c', 352, 41, 355, 38, 361, 37],
    ['c', 368, 37, 375, 40, 380, 45],
    ['c', 384, 50, 387, 55, 390, 60],
    ['c', 392, 62, 394, 64, 395, 66],
    ['c', 396, 66, 397, 66, 397, 65]
  ],
  bird2_v: [
    ['m', 611, 257],
    ['c', 609, 247, 598, 249, 590, 248],
    ['c', 580, 247, 569, 246, 559, 245],
    ['c', 559, 244, 559, 242, 558, 241],
    ['c', 563, 239, 567, 236, 571, 234],
    ['c', 581, 230, 591, 226, 600, 221],
    ['c', 607, 216, 614, 208, 609, 200],
    ['c', 606, 196, 596, 197, 589, 196],
    ['c', 588, 196, 587, 197, 586, 196],
    ['c', 574, 194, 562, 204, 548, 194],
    ['c', 557, 186, 566, 181, 573, 174],
    ['c', 580, 168, 586, 160, 590, 153],
    ['c', 594, 147, 590, 140, 583, 141],
    ['c', 568, 144, 551, 142, 538, 153],
    ['c', 529, 159, 518, 163, 507, 168],
    ['c', 507, 168, 506, 167, 506, 166],
    ['c', 526, 149, 557, 141, 552, 104],
    ['c', 524, 110, 501, 121, 479, 137],
    ['c', 483, 128, 487, 120, 491, 111],
    ['c', 494, 101, 491, 97, 481, 99],
    ['c', 475, 101, 468, 103, 463, 106],
    ['c', 439, 121, 416, 139, 398, 162],
    ['c', 391, 171, 383, 180, 376, 188],
    ['c', 375, 188, 374, 187, 374, 187],
    ['c', 376, 182, 379, 178, 380, 173],
    ['c', 384, 161, 388, 150, 390, 138],
    ['c', 391, 136, 388, 132, 386, 130],
    ['c', 385, 130, 381, 133, 379, 134],
    ['c', 377, 136, 377, 138, 376, 139],
    ['c', 365, 163, 355, 186, 344, 209],
    ['c', 343, 212, 342, 215, 339, 216],
    ['c', 311, 231, 293, 257, 278, 283],
    ['c', 268, 300, 257, 303, 241, 301],
    ['c', 238, 300, 235, 299, 232, 299],
    ['c', 211, 297, 190, 292, 170, 294],
    ['c', 154, 297, 137, 299, 123, 307],
    ['c', 109, 315, 82, 335, 84, 353],
    ['c', 84, 356, 87, 359, 87, 361],
    ['c', 86, 377, 62, 383, 73, 402],
    ['c', 74, 403, 103, 390, 107, 389],
    ['c', 118, 388, 127, 397, 137, 400],
    ['c', 152, 405, 158, 409, 162, 425],
    ['c', 165, 438, 169, 452, 181, 461],
    ['c', 197, 473, 203, 488, 209, 505],
    ['c', 214, 520, 202, 539, 189, 536],
    ['c', 169, 532, 148, 525, 128, 518],
    ['c', 118, 514, 106, 521, 95, 519],
    ['c', 86, 518, 80, 516, 77, 526],
    ['c', 76, 529, 68, 530, 66, 533],
    ['c', 63, 537, 64, 544, 65, 549],
    ['c', 67, 554, 68, 561, 71, 565],
    ['c', 72, 568, 73, 569, 75, 570],
    ['c', 77, 571, 81, 570, 82, 571],
    ['c', 80, 569, 75, 565, 75, 561],
    ['c', 75, 556, 79, 557, 82, 554],
    ['c', 82, 554, 83, 554, 83, 553],
    ['c', 80, 557, 82, 558, 84, 560],
    ['c', 84, 560, 88, 566, 89, 565],
    ['c', 89, 562, 86, 555, 90, 553],
    ['c', 96, 551, 96, 561, 103, 559],
    ['c', 106, 557, 109, 553, 113, 552],
    ['c', 119, 549, 125, 552, 132, 552],
    ['c', 132, 561, 129, 571, 120, 575],
    ['c', 125, 575, 132, 573, 136, 570],
    ['c', 141, 567, 139, 559, 146, 559],
    ['c', 151, 559, 160, 565, 164, 567],
    ['c', 170, 569, 177, 573, 182, 577],
    ['c', 187, 581, 194, 587, 202, 585],
    ['c', 208, 583, 211, 571, 216, 566],
    ['c', 223, 560, 229, 560, 235, 568],
    ['c', 236, 569, 238, 569, 240, 568],
    ['c', 250, 567, 261, 566, 270, 563],
    ['c', 278, 561, 283, 561, 290, 565],
    ['c', 302, 573, 314, 580, 329, 571],
    ['c', 332, 569, 337, 569, 340, 570],
    ['c', 352, 575, 364, 579, 375, 585],
    ['c', 386, 590, 391, 600, 397, 608],
    ['c', 406, 619, 412, 631, 417, 644],
    ['c', 422, 659, 429, 674, 438, 688],
    ['c', 441, 694, 443, 703, 447, 708],
    ['c', 451, 714, 459, 713, 460, 706],
    ['c', 461, 703, 452, 692, 458, 691],
    ['c', 463, 691, 463, 705, 466, 708],
    ['c', 472, 712, 481, 707, 486, 704],
    ['c', 496, 696, 482, 694, 486, 685],
    ['c', 487, 685, 488, 684, 490, 684],
    ['c', 494, 691, 499, 699, 505, 695],
    ['c', 506, 694, 507, 693, 508, 692],
    ['c', 510, 688, 511, 685, 515, 682],
    ['c', 519, 680, 526, 678, 522, 671],
    ['c', 518, 666, 512, 662, 508, 658],
    ['c', 478, 626, 451, 592, 424, 558],
    ['c', 418, 551, 413, 543, 407, 535],
    ['c', 420, 541, 427, 532, 437, 526],
    ['c', 427, 519, 418, 512, 407, 504],
    ['c', 413, 500, 419, 493, 423, 494],
    ['c', 442, 497, 449, 477, 464, 474],
    ['c', 470, 457, 493, 457, 499, 438],
    ['c', 504, 423, 517, 411, 525, 396],
    ['c', 529, 389, 529, 380, 531, 372],
    ['c', 529, 371, 529, 370, 529, 370],
    ['c', 547, 354, 571, 343, 573, 314],
    ['c', 573, 312, 576, 311, 578, 309],
    ['c', 592, 294, 592, 293, 573, 284],
    ['c', 573, 284, 573, 282, 572, 282],
    ['c', 580, 280, 588, 279, 594, 275],
    ['c', 602, 271, 613, 267, 611, 257],
    ['z'],
    ['m', 209, 549],
    ['c', 206, 553, 203, 557, 201, 561],
    ['c', 194, 573, 171, 553, 164, 548],
    ['c', 170, 548, 177, 549, 182, 552],
    ['c', 185, 555, 190, 561, 195, 560],
    ['c', 203, 558, 206, 547, 212, 544],
    ['c', 211, 546, 210, 547, 209, 549]
  ],
  bird2_h: [
    ['m', 505, 121],
    ['c', 503, 115, 497, 116, 492, 116],
    ['c', 486, 115, 480, 114, 473, 114],
    ['c', 473, 113, 473, 112, 473, 111],
    ['c', 476, 110, 478, 108, 481, 107],
    ['c', 487, 104, 493, 102, 498, 99],
    ['c', 502, 96, 507, 91, 503, 86],
    ['c', 502, 84, 496, 84, 492, 84],
    ['c', 491, 84, 490, 84, 490, 84],
    ['c', 483, 83, 475, 89, 466, 82],
    ['c', 472, 78, 477, 74, 482, 70],
    ['c', 486, 66, 490, 62, 492, 57],
    ['c', 494, 54, 492, 49, 488, 50],
    ['c', 478, 52, 469, 51, 460, 57],
    ['c', 455, 61, 448, 64, 442, 67],
    ['c', 442, 66, 441, 66, 441, 65],
    ['c', 453, 55, 472, 50, 469, 27],
    ['c', 452, 31, 438, 38, 425, 48],
    ['c', 427, 42, 430, 37, 432, 32],
    ['c', 434, 26, 432, 23, 426, 25],
    ['c', 422, 26, 418, 27, 415, 29],
    ['c', 400, 38, 386, 49, 375, 63],
    ['c', 371, 69, 366, 74, 362, 79],
    ['c', 361, 79, 361, 78, 360, 78],
    ['c', 362, 75, 364, 72, 365, 70],
    ['c', 367, 63, 369, 56, 371, 48],
    ['c', 371, 47, 369, 45, 368, 44],
    ['c', 367, 43, 365, 45, 364, 46],
    ['c', 363, 47, 362, 48, 362, 49],
    ['c', 355, 63, 349, 78, 343, 92],
    ['c', 342, 93, 341, 95, 340, 96],
    ['c', 322, 105, 311, 121, 302, 137],
    ['c', 296, 147, 290, 149, 280, 148],
    ['c', 278, 147, 276, 147, 275, 146],
    ['c', 262, 145, 249, 142, 236, 144],
    ['c', 226, 145, 216, 147, 208, 151],
    ['c', 199, 156, 183, 168, 184, 179],
    ['c', 184, 181, 186, 183, 186, 184],
    ['c', 186, 194, 171, 198, 178, 209],
    ['c', 178, 210, 196, 202, 198, 201],
    ['c', 205, 201, 210, 206, 217, 208],
    ['c', 225, 211, 229, 214, 232, 223],
    ['c', 234, 231, 236, 240, 243, 245],
    ['c', 253, 252, 256, 262, 260, 272],
    ['c', 263, 281, 256, 293, 248, 291],
    ['c', 236, 288, 223, 284, 211, 280],
    ['c', 205, 277, 198, 281, 191, 280],
    ['c', 185, 280, 181, 278, 180, 285],
    ['c', 179, 287, 175, 287, 173, 289],
    ['c', 171, 292, 172, 296, 173, 299],
    ['c', 174, 302, 175, 306, 176, 309],
    ['c', 177, 310, 177, 311, 179, 312],
    ['c', 180, 312, 182, 312, 183, 312],
    ['c', 181, 311, 179, 308, 179, 306],
    ['c', 179, 303, 181, 304, 183, 301],
    ['c', 183, 301, 183, 301, 183, 301],
    ['c', 182, 304, 183, 304, 184, 305],
    ['c', 184, 306, 187, 309, 187, 308],
    ['c', 187, 306, 186, 302, 188, 301],
    ['c', 191, 300, 192, 306, 196, 304],
    ['c', 198, 304, 199, 301, 202, 300],
    ['c', 206, 299, 209, 301, 213, 301],
    ['c', 213, 306, 211, 312, 206, 315],
    ['c', 209, 314, 213, 313, 216, 312],
    ['c', 219, 309, 218, 304, 222, 305],
    ['c', 225, 305, 230, 308, 233, 309],
    ['c', 236, 311, 241, 313, 244, 315],
    ['c', 247, 318, 251, 322, 256, 321],
    ['c', 260, 319, 261, 312, 264, 309],
    ['c', 269, 305, 272, 305, 276, 310],
    ['c', 277, 311, 278, 311, 279, 310],
    ['c', 285, 310, 292, 309, 298, 307],
    ['c', 302, 306, 305, 306, 310, 309],
    ['c', 317, 313, 324, 318, 333, 312],
    ['c', 335, 311, 338, 311, 340, 312],
    ['c', 347, 314, 355, 317, 362, 320],
    ['c', 368, 324, 371, 329, 375, 335],
    ['c', 380, 341, 384, 349, 387, 356],
    ['c', 390, 366, 394, 375, 399, 383],
    ['c', 402, 387, 403, 393, 405, 396],
    ['c', 407, 399, 412, 399, 413, 394],
    ['c', 413, 393, 408, 385, 412, 385],
    ['c', 415, 385, 415, 393, 417, 395],
    ['c', 420, 398, 426, 395, 429, 393],
    ['c', 435, 388, 427, 387, 429, 381],
    ['c', 429, 381, 430, 381, 431, 381],
    ['c', 434, 385, 437, 390, 440, 387],
    ['c', 441, 387, 441, 386, 442, 386],
    ['c', 444, 383, 444, 382, 447, 380],
    ['c', 449, 378, 453, 377, 450, 373],
    ['c', 448, 370, 445, 368, 442, 365],
    ['c', 424, 346, 408, 325, 391, 304],
    ['c', 388, 300, 384, 295, 381, 290],
    ['c', 389, 294, 393, 288, 399, 285],
    ['c', 393, 280, 387, 276, 381, 271],
    ['c', 385, 269, 388, 264, 391, 265],
    ['c', 402, 267, 406, 255, 415, 253],
    ['c', 419, 243, 433, 243, 437, 231],
    ['c', 440, 222, 448, 215, 453, 206],
    ['c', 455, 201, 455, 196, 456, 191],
    ['c', 455, 190, 455, 190, 455, 190],
    ['c', 466, 180, 481, 173, 482, 156],
    ['c', 482, 155, 484, 154, 485, 153],
    ['c', 493, 144, 493, 143, 482, 137],
    ['c', 482, 137, 482, 136, 481, 136],
    ['c', 486, 135, 491, 134, 495, 132],
    ['c', 500, 130, 506, 127, 505, 121],
    ['z'],
    ['m', 260, 299],
    ['c', 259, 301, 256, 303, 255, 306],
    ['c', 251, 314, 237, 301, 233, 298],
    ['c', 237, 298, 241, 299, 244, 301],
    ['c', 246, 302, 249, 306, 252, 305],
    ['c', 256, 304, 258, 297, 262, 295],
    ['c', 262, 297, 261, 298, 260, 299]
  ]
}

export const SVG_PATHS_TRANSFORM = {
  heart_v: 'translate(-3, -4) scale(0.039)',
  heart_h: 'translate(-12, -3.5) scale(0.064)',
  shield_v: 'translate(-1, -2) scale(0.036)',
  shield_h: 'translate(-11, -3) scale(0.064)',
  leaf_v: 'translate(-3, -3) scale(0.042)',
  leaf_h: 'translate(-8.5, -3) scale(0.058)',
  dog1_v: 'translate(-3, -3) scale(0.038)',
  dog1_h: 'translate(-8, 0) scale(0.053)',
  dog2_v: 'translate(1.5, -1.5) scale(0.03)',
  dog2_h: 'translate(-7, -1) scale(0.06)',
  bird1_h: 'translate(-4, -1) scale(0.045)',
  bird1_v: 'translate(-1, -3) scale(0.037)',
  bird2_v: 'translate(0, -3) scale(0.033)',
  bird2_h: 'translate(-7.5, -1) scale(0.055)',
  rabbit_v: 'translate(-2, -3) scale(0.038)',
  rabbit_h: 'translate(-8, -2) scale(0.055)',
  butterfly_v: 'translate(-3, -2) scale(0.039)',
  butterfly_h: 'translate(-7, -2) scale(0.053)',
  lion_v: 'translate(-3, -1.5) scale(0.041)',
  lion_h: 'translate(-4, 1) scale(0.043)',
  cammel_v: 'translate(-2, -1.5) scale(0.039)',
  cammel_h: 'translate(-7, 0) scale(0.049)',
  elephant_h: 'translate(-1, 2.5) scale(0.035)',
  elephant_v: 'translate(-1.5, 0) scale(0.038)',
  shark_v: 'translate(-1.4, -1.1) scale(0.039)',
  shark_h: 'translate(-1.5, 2) scale(0.038)'
}

/**
 * Mask name → the id a report param stores it under, ported from the cloud lib's `masks` table.
 *
 * The stored param carries the id, not the name, and the shape lookup is by name: an id that
 * reaches the renderer untranslated matches no SVG path, so the mask canvas stays all-white and
 * every pixel reads as occupied — a cloud that can never place a word.
 */
export const MASK_IDS = Object.freeze({
  heart: '2',
  shield: '6',
  leaf: '7',
  circle: '3',
  square: '5',
  diamond: '4',
  dog1: 'd',
  dog2: 'e',
  bird1: 'c',
  bird2: 'g',
  rabbit: 'f',
  butterfly: '1',
  lion: 'a',
  cammel: 'b',
  elephant: '8',
  shark: '9'
})

/**
 * Resolve a mask token to the name the renderer draws by.
 *
 * Accepts either form — the id a report param stores, or the name itself — so a caller can pass
 * its stored value straight through. A token that is neither resolves to no mask at all: an
 * unrecognized shape is better drawn as an unmasked cloud than as a blank one.
 *
 * @param {string} token - stored mask id, mask name, or empty
 * @returns {string} the mask name, or '' for no mask
 */
export const resolveMaskToken = token => {
  if (!token) return ''
  if (undefined !== MASK_IDS[token]) return token

  const name = Object.keys(MASK_IDS).find(key => MASK_IDS[key] === token)

  return name || ''
}

export default {
  BASIC_MASKS,
  SVG_PATHS,
  MASK_IDS,
  resolveMaskToken
}
